(window.webpackJsonp=window.webpackJsonp||[]).push([[1],{
/***/"1DlD":
/***/function(t,e,i){"use strict";
/* harmony export (binding) */i.d(e,"a",(function(){return n}));
/* harmony import */i("pYlh");
/* harmony import */var s=i("qEMp");
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
class n{
/**
   * @param {{
   *   type: (string|null|undefined),
   *   key: (string|null|undefined),
   *   value: *,
   * }=} options
   */
constructor(t){n[" "](t),
/** @type {string} */
this.type=t&&t.type||"default",
/** @type {string|null|undefined} */
this.key=t&&t.key,t&&"value"in t&&(
/** @type {*} */
this.value=t.value)}
/** @return {*} */get value(){var t=this.type,e=this.key;if(t&&e)return n.types[t]&&n.types[t][e]}
/** @param {*} value */set value(t){var e=this.type,i=this.key;e&&i&&(e=n.types[e]=n.types[e]||{},null==t?delete e[i]:e[i]=t)}
/** @return {!Array<*>} */get list(){if(this.type){var t=n.types[this.type];return t?Object.keys(t).map((function(t){return o[this.type][t]}),this):[]}}
/**
   * @param {string} key
   * @return {*}
   */byKey(t){return this.key=t,this.value}}// This function is used to convince Closure not to remove constructor calls
// for instances that are not held anywhere. For example, when
// `new IronMeta({...})` is used only for the side effect of adding a value.
n[" "]=function(){},n.types={};var o=n.types;
/**
`iron-meta` is a generic element you can use for sharing information across the
DOM tree. It uses [monostate pattern](http://c2.com/cgi/wiki?MonostatePattern)
such that any instance of iron-meta has access to the shared information. You
can use `iron-meta` to share whatever you want (or create an extension [like
x-meta] for enhancements).

The `iron-meta` instances containing your actual data can be loaded in an
import, or constructed in any way you see fit. The only requirement is that you
create them before you try to access them.

Examples:

If I create an instance like this:

    <iron-meta key="info" value="foo/bar"></iron-meta>

Note that value="foo/bar" is the metadata I've defined. I could define more
attributes or use child nodes to define additional metadata.

Now I can access that element (and it's metadata) from any iron-meta instance
via the byKey method, e.g.

    meta.byKey('info');

Pure imperative form would be like:

    document.createElement('iron-meta').byKey('info');

Or, in a Polymer element, you can include a meta in your template:

    <iron-meta id="meta"></iron-meta>
    ...
    this.$.meta.byKey('info');

@group Iron Elements
@demo demo/index.html
@element iron-meta
*/Object(s.a)({is:"iron-meta",properties:{
/**
     * The type of meta-data.  All meta-data of the same type is stored
     * together.
     * @type {string}
     */
type:{type:String,value:"default"},
/**
     * The key used to store `value` under the `type` namespace.
     * @type {?string}
     */
key:{type:String},
/**
     * The meta-data to store or retrieve.
     * @type {*}
     */
value:{type:String,notify:!0},
/**
     * If true, `value` is set to the iron-meta instance itself.
     */
self:{type:Boolean,observer:"_selfChanged"},__meta:{type:Boolean,computed:"__computeMeta(type, key, value)"}},hostAttributes:{hidden:!0},__computeMeta:function(t,e,i){var s=new n({type:t,key:e});return void 0!==i&&i!==s.value?s.value=i:this.value!==s.value&&(this.value=s.value),s},get list(){return this.__meta&&this.__meta.list},_selfChanged:function(t){t&&(this.value=this)},
/**
   * Retrieves meta data value by key.
   *
   * @method byKey
   * @param {string} key The key of the meta-data to be returned.
   * @return {*}
   */
byKey:function(t){return new n({type:this.type,key:t}).value}})},
/***/"1Ohj":
/***/function(t,e,i){"use strict";
/* harmony import */i("pYlh");
/* harmony import */
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/**
The `<iron-flex-layout>` component provides simple ways to use
[CSS flexible box
layout](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Flexible_boxes),
also known as flexbox. Note that this is an old element, that was written
before all modern browsers had non-prefixed flex styles. As such, nowadays you
don't really need to use this element anymore, and can use CSS flex styles
directly in your code.

This component provides two different ways to use flexbox:

1. [Layout
classes](https://github.com/PolymerElements/iron-flex-layout/tree/master/iron-flex-layout-classes.html).
The layout class stylesheet provides a simple set of class-based flexbox rules,
that let you specify layout properties directly in markup. You must include this
file in every element that needs to use them.

    Sample use:

    ```
    <custom-element-demo>
      <template>
        <script src="../webcomponentsjs/webcomponents-lite.js"><\/script>
        <next-code-block></next-code-block>
      </template>
    </custom-element-demo>
    ```

    ```js
    import {html} from '@polymer/polymer/lib/utils/html-tag.js';
    import '@polymer/iron-flex-layout/iron-flex-layout-classes.js';

    const template = html`
      <style is="custom-style" include="iron-flex iron-flex-alignment"></style>
      <style>
        .test { width: 100px; }
      </style>
      <div class="layout horizontal center-center">
        <div class="test">horizontal layout center alignment</div>
      </div>
    `;
    document.body.appendChild(template.content);
    ```

2. [Custom CSS
mixins](https://github.com/PolymerElements/iron-flex-layout/blob/master/iron-flex-layout.html).
The mixin stylesheet includes custom CSS mixins that can be applied inside a CSS
rule using the `@apply` function.

Please note that the old [/deep/ layout
classes](https://github.com/PolymerElements/iron-flex-layout/tree/master/classes)
are deprecated, and should not be used. To continue using layout properties
directly in markup, please switch to using the new `dom-module`-based
[layout
classes](https://github.com/PolymerElements/iron-flex-layout/tree/master/iron-flex-layout-classes.html).
Please note that the new version does not use `/deep/`, and therefore requires
you to import the `dom-modules` in every element that needs to use them.

@group Iron Elements
@pseudoElement iron-flex-layout
@demo demo/index.html
*/
const s=i("o5Wi").a`<custom-style><style is="custom-style">[hidden]{display:none!important}</style></custom-style><custom-style><style is="custom-style">html{--layout:{display:-ms-flexbox;display:-webkit-flex;display:flex};--layout-inline:{display:-ms-inline-flexbox;display:-webkit-inline-flex;display:inline-flex};--layout-horizontal:{@apply --layout;-ms-flex-direction:row;-webkit-flex-direction:row;flex-direction:row};--layout-horizontal-reverse:{@apply --layout;-ms-flex-direction:row-reverse;-webkit-flex-direction:row-reverse;flex-direction:row-reverse};--layout-vertical:{@apply --layout;-ms-flex-direction:column;-webkit-flex-direction:column;flex-direction:column};--layout-vertical-reverse:{@apply --layout;-ms-flex-direction:column-reverse;-webkit-flex-direction:column-reverse;flex-direction:column-reverse};--layout-wrap:{-ms-flex-wrap:wrap;-webkit-flex-wrap:wrap;flex-wrap:wrap};--layout-wrap-reverse:{-ms-flex-wrap:wrap-reverse;-webkit-flex-wrap:wrap-reverse;flex-wrap:wrap-reverse};--layout-flex-auto:{-ms-flex:1 1 auto;-webkit-flex:1 1 auto;flex:1 1 auto};--layout-flex-none:{-ms-flex:none;-webkit-flex:none;flex:none};--layout-flex:{-ms-flex:1 1 .000000001px;-webkit-flex:1;flex:1;-webkit-flex-basis:.000000001px;flex-basis:.000000001px};--layout-flex-2:{-ms-flex:2;-webkit-flex:2;flex:2};--layout-flex-3:{-ms-flex:3;-webkit-flex:3;flex:3};--layout-flex-4:{-ms-flex:4;-webkit-flex:4;flex:4};--layout-flex-5:{-ms-flex:5;-webkit-flex:5;flex:5};--layout-flex-6:{-ms-flex:6;-webkit-flex:6;flex:6};--layout-flex-7:{-ms-flex:7;-webkit-flex:7;flex:7};--layout-flex-8:{-ms-flex:8;-webkit-flex:8;flex:8};--layout-flex-9:{-ms-flex:9;-webkit-flex:9;flex:9};--layout-flex-10:{-ms-flex:10;-webkit-flex:10;flex:10};--layout-flex-11:{-ms-flex:11;-webkit-flex:11;flex:11};--layout-flex-12:{-ms-flex:12;-webkit-flex:12;flex:12};--layout-start:{-ms-flex-align:start;-webkit-align-items:flex-start;align-items:flex-start};--layout-center:{-ms-flex-align:center;-webkit-align-items:center;align-items:center};--layout-end:{-ms-flex-align:end;-webkit-align-items:flex-end;align-items:flex-end};--layout-baseline:{-ms-flex-align:baseline;-webkit-align-items:baseline;align-items:baseline};--layout-start-justified:{-ms-flex-pack:start;-webkit-justify-content:flex-start;justify-content:flex-start};--layout-center-justified:{-ms-flex-pack:center;-webkit-justify-content:center;justify-content:center};--layout-end-justified:{-ms-flex-pack:end;-webkit-justify-content:flex-end;justify-content:flex-end};--layout-around-justified:{-ms-flex-pack:distribute;-webkit-justify-content:space-around;justify-content:space-around};--layout-justified:{-ms-flex-pack:justify;-webkit-justify-content:space-between;justify-content:space-between};--layout-center-center:{@apply --layout-center;@apply --layout-center-justified;};--layout-self-start:{-ms-align-self:flex-start;-webkit-align-self:flex-start;align-self:flex-start};--layout-self-center:{-ms-align-self:center;-webkit-align-self:center;align-self:center};--layout-self-end:{-ms-align-self:flex-end;-webkit-align-self:flex-end;align-self:flex-end};--layout-self-stretch:{-ms-align-self:stretch;-webkit-align-self:stretch;align-self:stretch};--layout-self-baseline:{-ms-align-self:baseline;-webkit-align-self:baseline;align-self:baseline};--layout-start-aligned:{-ms-flex-line-pack:start;-ms-align-content:flex-start;-webkit-align-content:flex-start;align-content:flex-start};--layout-end-aligned:{-ms-flex-line-pack:end;-ms-align-content:flex-end;-webkit-align-content:flex-end;align-content:flex-end};--layout-center-aligned:{-ms-flex-line-pack:center;-ms-align-content:center;-webkit-align-content:center;align-content:center};--layout-between-aligned:{-ms-flex-line-pack:justify;-ms-align-content:space-between;-webkit-align-content:space-between;align-content:space-between};--layout-around-aligned:{-ms-flex-line-pack:distribute;-ms-align-content:space-around;-webkit-align-content:space-around;align-content:space-around};--layout-block:{display:block};--layout-invisible:{visibility:hidden!important};--layout-relative:{position:relative};--layout-fit:{position:absolute;top:0;right:0;bottom:0;left:0};--layout-scroll:{-webkit-overflow-scrolling:touch;overflow:auto};--layout-fullbleed:{margin:0;height:100vh};--layout-fixed-top:{position:fixed;top:0;left:0;right:0};--layout-fixed-right:{position:fixed;top:0;right:0;bottom:0};--layout-fixed-bottom:{position:fixed;right:0;bottom:0;left:0};--layout-fixed-left:{position:fixed;top:0;bottom:0;left:0};}</style></custom-style>`;s.setAttribute("style","display: none;"),document.head.appendChild(s.content);var n=document.createElement("style");n.textContent="[hidden] { display: none !important; }",document.head.appendChild(n)},
/***/"78gc":
/***/function(t,e,i){"use strict";
/* harmony export (binding) */i.d(e,"a",(function(){return p}));
/* harmony import */i("pYlh");
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/**
 * Chrome uses an older version of DOM Level 3 Keyboard Events
 *
 * Most keys are labeled as text, but some are Unicode codepoints.
 * Values taken from:
 * http://www.w3.org/TR/2007/WD-DOM-Level-3-Events-20071221/keyset.html#KeySet-Set
 */var s={"U+0008":"backspace","U+0009":"tab","U+001B":"esc","U+0020":"space","U+007F":"del"},n={8:"backspace",9:"tab",13:"enter",27:"esc",33:"pageup",34:"pagedown",35:"end",36:"home",32:"space",37:"left",38:"up",39:"right",40:"down",46:"del",106:"*"},o={shift:"shiftKey",ctrl:"ctrlKey",alt:"altKey",meta:"metaKey"},r=/[a-z0-9*]/,a=/U\+/,l=/^arrow/,h=/^space(bar)?/,c=/^escape$/;
/**
 * Transforms the key.
 * @param {string} key The KeyBoardEvent.key
 * @param {Boolean} [noSpecialChars] Limits the transformation to
 * alpha-numeric characters.
 */
function u(t,e){var i="";if(t){var s=t.toLowerCase();" "===s||h.test(s)?i="space":c.test(s)?i="esc":1==s.length?e&&!r.test(s)||(i=s):i=l.test(s)?s.replace("arrow",""):"multiply"==s?"*":s}return i}
/**
 * Calculates the normalized key for a KeyboardEvent.
 * @param {KeyboardEvent} keyEvent
 * @param {Boolean} [noSpecialChars] Set to true to limit keyEvent.key
 * transformation to alpha-numeric chars. This is useful with key
 * combinations like shift + 2, which on FF for MacOS produces
 * keyEvent.key = @
 * To get 2 returned, set noSpecialChars = true
 * To get @ returned, set noSpecialChars = false
 */
function d(t,e){
// Fall back from .key, to .detail.key for artifical keyboard events,
// and then to deprecated .keyIdentifier and .keyCode.
return t.key?u(t.key,e):t.detail&&t.detail.key?u(t.detail.key,e):(i=t.keyIdentifier,o="",i&&(i in s?o=s[i]:a.test(i)?(i=parseInt(i.replace("U+","0x"),16),o=String.fromCharCode(i).toLowerCase()):o=i.toLowerCase()),o||function(t){var e="";return Number(t)&&(
// ascii a-z
// lowercase is 32 offset from uppercase
e=t>=65&&t<=90?String.fromCharCode(32+t):t>=112&&t<=123?"f"+(t-112+1):t>=48&&t<=57?String(t-48):t>=96&&t<=105?String(t-96):n[t]),e}(t.keyCode)||"");var i,o}function f(t,e){return d(e,t.hasModifiers)===t.key&&(!t.hasModifiers||!!e.shiftKey==!!t.shiftKey&&!!e.ctrlKey==!!t.ctrlKey&&!!e.altKey==!!t.altKey&&!!e.metaKey==!!t.metaKey)}function _(t){return t.trim().split(" ").map((function(t){return function(t){return 1===t.length?{combo:t,key:t,event:"keydown"}:t.split("+").reduce((function(t,e){var i=e.split(":"),s=i[0],n=i[1];return s in o?(t[o[s]]=!0,t.hasModifiers=!0):(t.key=s,t.event=n||"keydown"),t}),{combo:t.split(":").shift()})}(t)}))}
/**
 * `Polymer.IronA11yKeysBehavior` provides a normalized interface for processing
 * keyboard commands that pertain to [WAI-ARIA best
 * practices](http://www.w3.org/TR/wai-aria-practices/#kbd_general_binding). The
 * element takes care of browser differences with respect to Keyboard events and
 * uses an expressive syntax to filter key presses.
 *
 * Use the `keyBindings` prototype property to express what combination of keys
 * will trigger the callback. A key binding has the format
 * `"KEY+MODIFIER:EVENT": "callback"` (`"KEY": "callback"` or
 * `"KEY:EVENT": "callback"` are valid as well). Some examples:
 *
 *      keyBindings: {
 *        'space': '_onKeydown', // same as 'space:keydown'
 *        'shift+tab': '_onKeydown',
 *        'enter:keypress': '_onKeypress',
 *        'esc:keyup': '_onKeyup'
 *      }
 *
 * The callback will receive with an event containing the following information
 * in `event.detail`:
 *
 *      _onKeydown: function(event) {
 *        console.log(event.detail.combo); // KEY+MODIFIER, e.g. "shift+tab"
 *        console.log(event.detail.key); // KEY only, e.g. "tab"
 *        console.log(event.detail.event); // EVENT, e.g. "keydown"
 *        console.log(event.detail.keyboardEvent); // the original KeyboardEvent
 *      }
 *
 * Use the `keyEventTarget` attribute to set up event handlers on a specific
 * node.
 *
 * See the [demo source
 * code](https://github.com/PolymerElements/iron-a11y-keys-behavior/blob/master/demo/x-key-aware.html)
 * for an example.
 *
 * @demo demo/index.html
 * @polymerBehavior
 */const p={properties:{
/**
     * The EventTarget that will be firing relevant KeyboardEvents. Set it to
     * `null` to disable the listeners.
     * @type {?EventTarget}
     */
keyEventTarget:{type:Object,value:function(){return this}},
/**
     * If true, this property will cause the implementing element to
     * automatically stop propagation on any handled KeyboardEvents.
     */
stopKeyboardEventPropagation:{type:Boolean,value:!1},_boundKeyHandlers:{type:Array,value:function(){return[]}},
// We use this due to a limitation in IE10 where instances will have
// own properties of everything on the "prototype".
_imperativeKeyBindings:{type:Object,value:function(){return{}}}},observers:["_resetKeyEventListeners(keyEventTarget, _boundKeyHandlers)"],
/**
   * To be used to express what combination of keys  will trigger the relative
   * callback. e.g. `keyBindings: { 'esc': '_onEscPressed'}`
   * @type {!Object}
   */
keyBindings:{},registered:function(){this._prepKeyBindings()},attached:function(){this._listenKeyEventListeners()},detached:function(){this._unlistenKeyEventListeners()},
/**
   * Can be used to imperatively add a key binding to the implementing
   * element. This is the imperative equivalent of declaring a keybinding
   * in the `keyBindings` prototype property.
   *
   * @param {string} eventString
   * @param {string} handlerName
   */
addOwnKeyBinding:function(t,e){this._imperativeKeyBindings[t]=e,this._prepKeyBindings(),this._resetKeyEventListeners()},
/**
   * When called, will remove all imperatively-added key bindings.
   */
removeOwnKeyBindings:function(){this._imperativeKeyBindings={},this._prepKeyBindings(),this._resetKeyEventListeners()},
/**
   * Returns true if a keyboard event matches `eventString`.
   *
   * @param {KeyboardEvent} event
   * @param {string} eventString
   * @return {boolean}
   */
keyboardEventMatchesKeys:function(t,e){for(var i=_(e),s=0;s<i.length;++s)if(f(i[s],t))return!0;return!1},_collectKeyBindings:function(){var t=this.behaviors.map((function(t){return t.keyBindings}));return-1===t.indexOf(this.keyBindings)&&t.push(this.keyBindings),t},_prepKeyBindings:function(){for(var t in this._keyBindings={},this._collectKeyBindings().forEach((function(t){for(var e in t)this._addKeyBinding(e,t[e])}),this),this._imperativeKeyBindings)this._addKeyBinding(t,this._imperativeKeyBindings[t]);// Give precedence to combos with modifiers to be checked first.
for(var e in this._keyBindings)this._keyBindings[e].sort((function(t,e){var i=t[0].hasModifiers;return i===e[0].hasModifiers?0:i?-1:1}))},_addKeyBinding:function(t,e){_(t).forEach((function(t){this._keyBindings[t.event]=this._keyBindings[t.event]||[],this._keyBindings[t.event].push([t,e])}),this)},_resetKeyEventListeners:function(){this._unlistenKeyEventListeners(),this.isAttached&&this._listenKeyEventListeners()},_listenKeyEventListeners:function(){this.keyEventTarget&&Object.keys(this._keyBindings).forEach((function(t){var e=this._keyBindings[t],i=this._onKeyBindingEvent.bind(this,e);this._boundKeyHandlers.push([this.keyEventTarget,t,i]),this.keyEventTarget.addEventListener(t,i)}),this)},_unlistenKeyEventListeners:function(){for(var t,e,i,s;this._boundKeyHandlers.length;)
// My kingdom for block-scope binding and destructuring assignment..
e=(t=this._boundKeyHandlers.pop())[0],i=t[1],s=t[2],e.removeEventListener(i,s)},_onKeyBindingEvent:function(t,e){// if event has been already prevented, don't do anything
if(this.stopKeyboardEventPropagation&&e.stopPropagation(),!e.defaultPrevented)for(var i=0;i<t.length;i++){var s=t[i][0],n=t[i][1];if(f(s,e)&&(this._triggerKeyHandler(s,n,e),e.defaultPrevented))return}},_triggerKeyHandler:function(t,e,i){var s=Object.create(t);s.keyboardEvent=i;var n=new CustomEvent(t.event,{detail:s,cancelable:!0});this[e].call(this,n),n.defaultPrevented&&i.preventDefault()}};
/***/},
/***/"7i8T":
/***/function(t,e,i){"use strict";
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
// ensure this file can only be parsed as a module.
// Give the user the choice to opt out of font loading.
if(!window.polymerSkipLoadingFontRoboto){const t=document.createElement("link");t.rel="stylesheet",t.type="text/css",t.crossOrigin="anonymous",t.href="https://fonts.googleapis.com/css?family=Roboto+Mono:400,700|Roboto:400,300,300italic,400italic,500,500italic,700,700italic",document.head.appendChild(t)}
/***/},
/***/F0SK:
/***/function(t,e,i){"use strict";
/* harmony export (binding) */i.d(e,"a",(function(){return o}));
/* harmony import */i("pYlh");
/* harmony import */var s=i("qEMp"),n=i("o5Wi");
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/**
`iron-a11y-announcer` is a singleton element that is intended to add a11y
to features that require on-demand announcement from screen readers. In
order to make use of the announcer, it is best to request its availability
in the announcing element.

Example:

    Polymer({

      is: 'x-chatty',

      attached: function() {
        // This will create the singleton element if it has not
        // been created yet:
        Polymer.IronA11yAnnouncer.requestAvailability();
      }
    });

After the `iron-a11y-announcer` has been made available, elements can
make announces by firing bubbling `iron-announce` events.

Example:

    this.fire('iron-announce', {
      text: 'This is an announcement!'
    }, { bubbles: true });

Note: announcements are only audible if you have a screen reader enabled.

@demo demo/index.html
*/
const o=Object(s.a)({
/** @override */
_template:n.a`<style>:host{display:inline-block;position:fixed;clip:rect(0,0,0,0)}</style><div aria-live$="[[mode]]">[[_text]]</div>`,is:"iron-a11y-announcer",properties:{
/**
     * The value of mode is used to set the `aria-live` attribute
     * for the element that will be announced. Valid values are: `off`,
     * `polite` and `assertive`.
     */
mode:{type:String,value:"polite"},
/**
     * The timeout on refreshing the announcement text. Larger timeouts are
     * needed for certain screen readers to re-announce the same message.
     */
timeout:{type:Number,value:150},_text:{type:String,value:""}},
/** @override */
created:function(){o.instance||(o.instance=this),document.addEventListener("iron-announce",this._onIronAnnounce.bind(this))},
/**
   * Cause a text string to be announced by screen readers.
   *
   * @param {string} text The text that should be announced.
   */
announce:function(t){this._text="",this.async((function(){this._text=t}),this.timeout)},_onIronAnnounce:function(t){t.detail&&t.detail.text&&this.announce(t.detail.text)}});o.instance=null,o.requestAvailability=function(){o.instance||(o.instance=document.createElement("iron-a11y-announcer")),document.body?document.body.appendChild(o.instance):document.addEventListener("load",(function(){document.body.appendChild(o.instance)}))}},
/***/G2f5:
/***/function(t,e,i){"use strict";
/* harmony export (binding) */i.d(e,"b",(function(){return o})),
/* harmony export (binding) */i.d(e,"a",(function(){return r}));
/* harmony import */i("pYlh"),i("Z+yT")
/* harmony import */;var s=i("78gc"),n=i("hvZu");
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/**
 * @demo demo/index.html
 * @polymerBehavior IronButtonState
 */
const o={properties:{
/**
     * If true, the user is currently holding down the button.
     */
pressed:{type:Boolean,readOnly:!0,value:!1,reflectToAttribute:!0,observer:"_pressedChanged"},
/**
     * If true, the button toggles the active state with each tap or press
     * of the spacebar.
     */
toggles:{type:Boolean,value:!1,reflectToAttribute:!0},
/**
     * If true, the button is a toggle and is currently in the active state.
     */
active:{type:Boolean,value:!1,notify:!0,reflectToAttribute:!0},
/**
     * True if the element is currently being pressed by a "pointer," which
     * is loosely defined as mouse or touch input (but specifically excluding
     * keyboard input).
     */
pointerDown:{type:Boolean,readOnly:!0,value:!1},
/**
     * True if the input device that caused the element to receive focus
     * was a keyboard.
     */
receivedFocusFromKeyboard:{type:Boolean,readOnly:!0},
/**
     * The aria attribute to be set if the button is a toggle and in the
     * active state.
     */
ariaActiveAttribute:{type:String,value:"aria-pressed",observer:"_ariaActiveAttributeChanged"}},listeners:{down:"_downHandler",up:"_upHandler",tap:"_tapHandler"},observers:["_focusChanged(focused)","_activeChanged(active, ariaActiveAttribute)"],
/**
   * @type {!Object}
   */
keyBindings:{"enter:keydown":"_asyncClick","space:keydown":"_spaceKeyDownHandler","space:keyup":"_spaceKeyUpHandler"},_mouseEventRe:/^mouse/,_tapHandler:function(){this.toggles?
// a tap is needed to toggle the active state
this._userActivate(!this.active):this.active=!1},_focusChanged:function(t){this._detectKeyboardFocus(t),t||this._setPressed(!1)},_detectKeyboardFocus:function(t){this._setReceivedFocusFromKeyboard(!this.pointerDown&&t)},
// to emulate native checkbox, (de-)activations from a user interaction fire
// 'change' events
_userActivate:function(t){this.active!==t&&(this.active=t,this.fire("change"))},_downHandler:function(t){this._setPointerDown(!0),this._setPressed(!0),this._setReceivedFocusFromKeyboard(!1)},_upHandler:function(){this._setPointerDown(!1),this._setPressed(!1)},
/**
   * @param {!KeyboardEvent} event .
   */
_spaceKeyDownHandler:function(t){var e=t.detail.keyboardEvent,i=Object(n.a)(e).localTarget;// Ignore the event if this is coming from a focused light child, since that
// element will deal with it.
this.isLightDescendant(
/** @type {Node} */
i)||(e.preventDefault(),e.stopImmediatePropagation(),this._setPressed(!0))},
/**
   * @param {!KeyboardEvent} event .
   */
_spaceKeyUpHandler:function(t){var e=t.detail.keyboardEvent,i=Object(n.a)(e).localTarget;// Ignore the event if this is coming from a focused light child, since that
// element will deal with it.
this.isLightDescendant(
/** @type {Node} */
i)||(this.pressed&&this._asyncClick(),this._setPressed(!1))},
// trigger click asynchronously, the asynchrony is useful to allow one
// event handler to unwind before triggering another event
_asyncClick:function(){this.async((function(){this.click()}),1)},
// any of these changes are considered a change to button state
_pressedChanged:function(t){this._changedButtonState()},_ariaActiveAttributeChanged:function(t,e){e&&e!=t&&this.hasAttribute(e)&&this.removeAttribute(e)},_activeChanged:function(t,e){this.toggles?this.setAttribute(this.ariaActiveAttribute,t?"true":"false"):this.removeAttribute(this.ariaActiveAttribute),this._changedButtonState()},_controlStateChanged:function(){this.disabled?this._setPressed(!1):this._changedButtonState()},
// provide hook for follow-on behaviors to react to button-state
_changedButtonState:function(){this._buttonStateChanged&&this._buttonStateChanged()}},r=[s.a,o];
/** @polymerBehavior */},
/***/KR5w:
/***/function(t,e,i){"use strict";
/* harmony import */i("1Ohj"),i("1DlD")
/* harmony import */;var s=i("qEMp"),n=i("hvZu"),o=i("o5Wi"),r=i("pYlh");
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/**

The `iron-icon` element displays an icon. By default an icon renders as a 24px
square.

Example using src:

    <iron-icon src="star.png"></iron-icon>

Example setting size to 32px x 32px:

    <iron-icon class="big" src="big_star.png"></iron-icon>

    <style is="custom-style">
      .big {
        --iron-icon-height: 32px;
        --iron-icon-width: 32px;
      }
    </style>

The iron elements include several sets of icons. To use the default set of
icons, import `iron-icons.js` and use the `icon` attribute to specify an icon:

    <script type="module">
      import "@polymer/iron-icons/iron-icons.js";
    <\/script>

    <iron-icon icon="menu"></iron-icon>

To use a different built-in set of icons, import the specific
`iron-icons/<iconset>-icons.js`, and specify the icon as `<iconset>:<icon>`.
For example, to use a communication icon, you would use:

    <script type="module">
      import "@polymer/iron-icons/communication-icons.js";
    </script>

    <iron-icon icon="communication:email"></iron-icon>

You can also create custom icon sets of bitmap or SVG icons.

Example of using an icon named `cherry` from a custom iconset with the ID
`fruit`:

    <iron-icon icon="fruit:cherry"></iron-icon>

See `<iron-iconset>` and `<iron-iconset-svg>` for more information about how to
create a custom iconset.

See the `iron-icons` demo to see the icons available in the various iconsets.

### Styling

The following custom properties are available for styling:

Custom property | Description | Default
----------------|-------------|----------
`--iron-icon` | Mixin applied to the icon | {}
`--iron-icon-width` | Width of the icon | `24px`
`--iron-icon-height` | Height of the icon | `24px`
`--iron-icon-fill-color` | Fill color of the svg icon | `currentcolor`
`--iron-icon-stroke-color` | Stroke color of the svg icon | none

@group Iron Elements
@element iron-icon
@demo demo/index.html
@hero hero.svg
@homepage polymer.github.io
*/
Object(s.a)({_template:o.a`<style>:host{@apply --layout-inline;@apply --layout-center-center;position:relative;vertical-align:middle;fill:var(--iron-icon-fill-color,currentcolor);stroke:var(--iron-icon-stroke-color,none);width:var(--iron-icon-width,24px);height:var(--iron-icon-height,24px);@apply --iron-icon;}:host([hidden]){display:none}</style>`,is:"iron-icon",properties:{
/**
     * The name of the icon to use. The name should be of the form:
     * `iconset_name:icon_name`.
     */
icon:{type:String},
/**
     * The name of the theme to used, if one is specified by the
     * iconset.
     */
theme:{type:String},
/**
     * If using iron-icon without an iconset, you can set the src to be
     * the URL of an individual icon image file. Note that this will take
     * precedence over a given icon attribute.
     */
src:{type:String},
/**
     * @type {!IronMeta}
     */
_meta:{value:r.a.create("iron-meta",{type:"iconset"})}},observers:["_updateIcon(_meta, isAttached)","_updateIcon(theme, isAttached)","_srcChanged(src, isAttached)","_iconChanged(icon, isAttached)"],_DEFAULT_ICONSET:"icons",_iconChanged:function(t){var e=(t||"").split(":");this._iconName=e.pop(),this._iconsetName=e.pop()||this._DEFAULT_ICONSET,this._updateIcon()},_srcChanged:function(t){this._updateIcon()},_usesIconset:function(){return this.icon||!this.src},
/** @suppress {visibility} */
_updateIcon:function(){this._usesIconset()?(this._img&&this._img.parentNode&&Object(n.a)(this.root).removeChild(this._img),""===this._iconName?this._iconset&&this._iconset.removeIcon(this):this._iconsetName&&this._meta&&(this._iconset=
/** @type {?Polymer.Iconset} */
this._meta.byKey(this._iconsetName),this._iconset?(this._iconset.applyIcon(this,this._iconName,this.theme),this.unlisten(window,"iron-iconset-added","_updateIcon")):this.listen(window,"iron-iconset-added","_updateIcon"))):(this._iconset&&this._iconset.removeIcon(this),this._img||(this._img=document.createElement("img"),this._img.style.width="100%",this._img.style.height="100%",this._img.draggable=!1),this._img.src=this.src,Object(n.a)(this.root).appendChild(this._img))}})},
/***/POUH:
/***/function(t,e,i){"use strict";
/* harmony import */i("pYlh");
/* harmony import */var s=i("qEMp");
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/**
`iron-media-query` can be used to data bind to a CSS media query.
The `query` property is a bare CSS media query.
The `query-matches` property is a boolean representing whether the page matches
that media query.

Example:

```html
<iron-media-query query="(min-width: 600px)" query-matches="{{queryMatches}}">
</iron-media-query>
```

@group Iron Elements
@demo demo/index.html
@hero hero.svg
@element iron-media-query
*/
Object(s.a)({is:"iron-media-query",properties:{
/**
     * The Boolean return value of the media query.
     */
queryMatches:{type:Boolean,value:!1,readOnly:!0,notify:!0},
/**
     * The CSS media query to evaluate.
     */
query:{type:String,observer:"queryChanged"},
/**
     * If true, the query attribute is assumed to be a complete media query
     * string rather than a single media feature.
     */
full:{type:Boolean,value:!1},
/**
     * @type {function(MediaQueryList)}
     */
_boundMQHandler:{value:function(){return this.queryHandler.bind(this)}},
/**
     * @type {MediaQueryList}
     */
_mq:{value:null}},attached:function(){this.style.display="none",this.queryChanged()},detached:function(){this._remove()},_add:function(){this._mq&&this._mq.addListener(this._boundMQHandler)},_remove:function(){this._mq&&this._mq.removeListener(this._boundMQHandler),this._mq=null},queryChanged:function(){this._remove();var t=this.query;t&&(this.full||"("===t[0]||(t="("+t+")"),this._mq=window.matchMedia(t),this._add(),this.queryHandler(this._mq))},queryHandler:function(t){this._setQueryMatches(t.matches)}})},
/***/"Z+yT":
/***/function(t,e,i){"use strict";
/* harmony export (binding) */i.d(e,"a",(function(){return s}));
/* harmony import */i("pYlh"),i("hvZu")
/* harmony import */;
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/**
 * @demo demo/index.html
 * @polymerBehavior
 */
const s={properties:{
/**
     * If true, the element currently has focus.
     */
focused:{type:Boolean,value:!1,notify:!0,readOnly:!0,reflectToAttribute:!0},
/**
     * If true, the user cannot interact with this element.
     */
disabled:{type:Boolean,value:!1,notify:!0,observer:"_disabledChanged",reflectToAttribute:!0},
/**
     * Value of the `tabindex` attribute before `disabled` was activated.
     * `null` means the attribute was not present.
     * @type {?string|undefined}
     */
_oldTabIndex:{type:String},_boundFocusBlurHandler:{type:Function,value:function(){return this._focusBlurHandler.bind(this)}}},observers:["_changedControlState(focused, disabled)"],
/**
   * @return {void}
   */
ready:function(){this.addEventListener("focus",this._boundFocusBlurHandler,!0),this.addEventListener("blur",this._boundFocusBlurHandler,!0)},_focusBlurHandler:function(t){
// Polymer takes care of retargeting events.
this._setFocused("focus"===t.type)},_disabledChanged:function(t,e){this.setAttribute("aria-disabled",t?"true":"false"),this.style.pointerEvents=t?"none":"",t?(
// Read the `tabindex` attribute instead of the `tabIndex` property.
// The property returns `-1` if there is no `tabindex` attribute.
// This distinction is important when restoring the value because
// leaving `-1` hides shadow root children from the tab order.
this._oldTabIndex=this.getAttribute("tabindex"),this._setFocused(!1),this.tabIndex=-1,this.blur()):void 0!==this._oldTabIndex&&(null===this._oldTabIndex?this.removeAttribute("tabindex"):this.setAttribute("tabindex",this._oldTabIndex))},_changedControlState:function(){
// _controlStateChanged is abstract, follow-on behaviors may implement it
this._controlStateChanged&&this._controlStateChanged()}};
/***/},
/***/Z726:
/***/function(t,e,i){"use strict";
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/lib/legacy/polymer-fn.js?babel-target=es6
var s=i("qEMp"),n=i("pYlh");
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/polymer-legacy.js?babel-target=es6
// CONCATENATED MODULE: ./node_modules/@polymer/iron-ajax/iron-request.js?babel-target=es6
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/*
iron-request can be used to perform XMLHttpRequests.

    <iron-request id="xhr"></iron-request>
    ...
    this.$.xhr.send({url: url, body: params});
*/
Object(s.a)({is:"iron-request",hostAttributes:{hidden:!0},properties:{
/**
     * A reference to the XMLHttpRequest instance used to generate the
     * network request.
     *
     * @type {XMLHttpRequest}
     */
xhr:{type:Object,notify:!0,readOnly:!0,value:function(){return new XMLHttpRequest}},
/**
     * A reference to the parsed response body, if the `xhr` has completely
     * resolved.
     *
     * @type {*}
     * @default null
     */
response:{type:Object,notify:!0,readOnly:!0,value:function(){return null}},
/**
     * A reference to the status code, if the `xhr` has completely resolved.
     */
status:{type:Number,notify:!0,readOnly:!0,value:0},
/**
     * A reference to the status text, if the `xhr` has completely resolved.
     */
statusText:{type:String,notify:!0,readOnly:!0,value:""},
/**
     * A promise that resolves when the `xhr` response comes back, or rejects
     * if there is an error before the `xhr` completes.
     * The resolve callback is called with the original request as an argument.
     * By default, the reject callback is called with an `Error` as an argument.
     * If `rejectWithRequest` is true, the reject callback is called with an
     * object with two keys: `request`, the original request, and `error`, the
     * error object.
     *
     * @type {Promise}
     */
completes:{type:Object,readOnly:!0,notify:!0,value:function(){return new Promise(function(t,e){this.resolveCompletes=t,this.rejectCompletes=e}.bind(this))}},
/**
     * An object that contains progress information emitted by the XHR if
     * available.
     *
     * @default {}
     */
progress:{type:Object,notify:!0,readOnly:!0,value:function(){return{}}},
/**
     * Aborted will be true if an abort of the request is attempted.
     */
aborted:{type:Boolean,notify:!0,readOnly:!0,value:!1},
/**
     * Errored will be true if the browser fired an error event from the
     * XHR object (mainly network errors).
     */
errored:{type:Boolean,notify:!0,readOnly:!0,value:!1},
/**
     * TimedOut will be true if the XHR threw a timeout event.
     */
timedOut:{type:Boolean,notify:!0,readOnly:!0,value:!1}},
/**
   * Succeeded is true if the request succeeded. The request succeeded if it
   * loaded without error, wasn't aborted, and the status code is ≥ 200, and
   * < 300, or if the status code is 0.
   *
   * The status code 0 is accepted as a success because some schemes - e.g.
   * file:// - don't provide status codes.
   *
   * @return {boolean}
   */
get succeeded(){if(this.errored||this.aborted||this.timedOut)return!1;var t=this.xhr.status||0;// Note: if we are using the file:// protocol, the status code will be 0
// for all outcomes (successful or otherwise).
return 0===t||t>=200&&t<300},
/**
   * Sends an HTTP request to the server and returns a promise (see the
   * `completes` property for details).
   *
   * The handling of the `body` parameter will vary based on the Content-Type
   * header. See the docs for iron-ajax's `body` property for details.
   *
   * @param {{
   *   url: string,
   *   method: (string|undefined),
   *   async: (boolean|undefined),
   *   body:
   * (ArrayBuffer|ArrayBufferView|Blob|Document|FormData|null|string|undefined|Object),
   *   headers: (Object|undefined),
   *   handleAs: (string|undefined),
   *   jsonPrefix: (string|undefined),
   *   withCredentials: (boolean|undefined),
   *   timeout: (number|undefined),
   *   rejectWithRequest: (boolean|undefined)}} options -
   *   - url The url to which the request is sent.
   *   - method The HTTP method to use, default is GET.
   *   - async By default, all requests are sent asynchronously. To send
   * synchronous requests, set to false.
   *   -  body The content for the request body for POST method.
   *   -  headers HTTP request headers.
   *   -  handleAs The response type. Default is 'text'.
   *   -  withCredentials Whether or not to send credentials on the request.
   * Default is false.
   *   -  timeout - Timeout for request, in milliseconds.
   *   -  rejectWithRequest Set to true to include the request object with
   * promise rejections.
   * @return {Promise}
   */
send:function(t){var e=this.xhr;if(e.readyState>0)return null;e.addEventListener("progress",function(t){this._setProgress({lengthComputable:t.lengthComputable,loaded:t.loaded,total:t.total}),// Webcomponents v1 spec does not fire *-changed events when not connected
this.fire("iron-request-progress-changed",{value:this.progress})}.bind(this)),e.addEventListener("error",function(e){this._setErrored(!0),this._updateStatus();var i=t.rejectWithRequest?{error:e,request:this}:e;this.rejectCompletes(i)}.bind(this)),e.addEventListener("timeout",function(e){this._setTimedOut(!0),this._updateStatus();var i=t.rejectWithRequest?{error:e,request:this}:e;this.rejectCompletes(i)}.bind(this)),e.addEventListener("abort",function(){this._setAborted(!0),this._updateStatus();var e=new Error("Request aborted."),i=t.rejectWithRequest?{error:e,request:this}:e;this.rejectCompletes(i)}.bind(this)),// Called after all of the above.
e.addEventListener("loadend",function(){if(this._updateStatus(),this._setResponse(this.parseResponse()),this.succeeded)this.resolveCompletes(this);else{var e=new Error("The request failed with status code: "+this.xhr.status),i=t.rejectWithRequest?{error:e,request:this}:e;this.rejectCompletes(i)}}.bind(this)),this.url=t.url;var i=!1!==t.async;e.open(t.method||"GET",t.url,i);var s={json:"application/json",text:"text/plain",html:"text/html",xml:"application/xml",arraybuffer:"application/octet-stream"}[t.handleAs],o=t.headers||Object.create(null),r=Object.create(null);for(var a in o)r[a.toLowerCase()]=o[a];if(o=r,s&&!o.accept&&(o.accept=s),Object.keys(o).forEach((function(t){/[A-Z]/.test(t)&&n.a._error("Headers must be lower case, got",t),e.setRequestHeader(t,o[t])}),this),i){e.timeout=t.timeout;var l=t.handleAs;// If a JSON prefix is present, the responseType must be 'text' or the
// browser won’t be able to parse the response.
!t.jsonPrefix&&l||(l="text"),// In IE, `xhr.responseType` is an empty string when the response
// returns. Hence, caching it as `xhr._responseType`.
e.responseType=e._responseType=l,// Cache the JSON prefix, if it exists.
t.jsonPrefix&&(e._jsonPrefix=t.jsonPrefix)}e.withCredentials=!!t.withCredentials;var h=this._encodeBodyObject(t.body,o["content-type"]);return e.send(
/**
       @type {ArrayBuffer|ArrayBufferView|Blob|Document|FormData|
               null|string|undefined}
     */
h),this.completes},
/**
   * Attempts to parse the response body of the XHR. If parsing succeeds,
   * the value returned will be deserialized based on the `responseType`
   * set on the XHR.
   *
   * @return {*} The parsed response,
   * or undefined if there was an empty response or parsing failed.
   */
parseResponse:function(){var t=this.xhr,e=t.responseType||t._responseType,i=!this.xhr.responseType,s=t._jsonPrefix&&t._jsonPrefix.length||0;try{switch(e){case"json":
// If the xhr object doesn't have a natural `xhr.responseType`,
// we can assume that the browser hasn't parsed the response for us,
// and so parsing is our responsibility. Likewise if response is
// undefined, as there's no way to encode undefined in JSON.
if(i||void 0===t.response)
// Try to emulate the JSON section of the response body section of
// the spec: https://xhr.spec.whatwg.org/#response-body
// That is to say, we try to parse as JSON, but if anything goes
// wrong return null.
try{return JSON.parse(t.responseText)}catch(e){return console.warn("Failed to parse JSON sent from "+t.responseURL),null}return t.response;case"xml":return t.responseXML;case"blob":case"document":case"arraybuffer":return t.response;case"text":default:
// If `prefixLen` is set, it implies the response should be parsed
// as JSON once the prefix of length `prefixLen` is stripped from
// it. Emulate the behavior above where null is returned on failure
// to parse.
if(s)try{return JSON.parse(t.responseText.substring(s))}catch(e){return console.warn("Failed to parse JSON sent from "+t.responseURL),null}return t.responseText}}catch(t){this.rejectCompletes(new Error("Could not parse response. "+t.message))}},
/**
   * Aborts the request.
   */
abort:function(){this._setAborted(!0),this.xhr.abort()},
/**
   * @param {*} body The given body of the request to try and encode.
   * @param {?string} contentType The given content type, to infer an encoding
   *     from.
   * @return {*} Either the encoded body as a string, if successful,
   *     or the unaltered body object if no encoding could be inferred.
   */
_encodeBodyObject:function(t,e){if("string"==typeof t)return t;// Already encoded.
var i=
/** @type {Object} */
t;switch(e){case"application/json":return JSON.stringify(i);case"application/x-www-form-urlencoded":return this._wwwFormUrlEncode(i)}return t},
/**
   * @param {Object} object The object to encode as x-www-form-urlencoded.
   * @return {string} .
   */
_wwwFormUrlEncode:function(t){if(!t)return"";var e=[];return Object.keys(t).forEach((function(i){
// TODO(rictic): handle array values here, in a consistent way with
//   iron-ajax params.
e.push(this._wwwFormUrlEncodePiece(i)+"="+this._wwwFormUrlEncodePiece(t[i]))}),this),e.join("&")},
/**
   * @param {*} str A key or value to encode as x-www-form-urlencoded.
   * @return {string} .
   */
_wwwFormUrlEncodePiece:function(t){
// Spec says to normalize newlines to \r\n and replace %20 spaces with +.
// jQuery does this as well, so this is likely to be widely compatible.
return null!=t&&t.toString?encodeURIComponent(t.toString().replace(/\r?\n/g,"\r\n")).replace(/%20/g,"+"):""},
/**
   * Updates the status code and status text.
   */
_updateStatus:function(){this._setStatus(this.xhr.status),this._setStatusText(void 0===this.xhr.statusText?"":this.xhr.statusText)}}),
// CONCATENATED MODULE: ./node_modules/@polymer/iron-ajax/iron-ajax.js?babel-target=es6
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/**
The `iron-ajax` element exposes network request functionality.

    <iron-ajax
        auto
        url="https://www.googleapis.com/youtube/v3/search"
        params='{"part":"snippet", "q":"polymer", "key": "YOUTUBE_API_KEY",
"type": "video"}' handle-as="json" on-response="handleResponse"
        debounce-duration="300"></iron-ajax>

With `auto` set to `true`, the element performs a request whenever
its `url`, `params` or `body` properties are changed. Automatically generated
requests will be debounced in the case that multiple attributes are changed
sequentially.

Note: The `params` attribute must be double quoted JSON.

You can trigger a request explicitly by calling `generateRequest` on the
element.

@demo demo/index.html
*/
Object(s.a)({is:"iron-ajax",
/**
   * Fired before a request is sent.
   *
   * @event iron-ajax-presend
   */
/**
   * Fired when a request is sent.
   *
   * @event request
   */
/**
   * Fired when a request is sent.
   *
   * @event iron-ajax-request
   */
/**
   * Fired when a response is received.
   *
   * @event response
   */
/**
   * Fired when a response is received.
   *
   * @event iron-ajax-response
   */
/**
   * Fired when an error is received.
   *
   * @event error
   */
/**
   * Fired when an error is received.
   *
   * @event iron-ajax-error
   */
hostAttributes:{hidden:!0},properties:{
/**
     * The URL target of the request.
     */
url:{type:String},
/**
     * An object that contains query parameters to be appended to the
     * specified `url` when generating a request. If you wish to set the body
     * content when making a POST request, you should use the `body` property
     * instead.
     */
params:{type:Object,value:function(){return{}}},
/**
     * The HTTP method to use such as 'GET', 'POST', 'PUT', or 'DELETE'.
     * Default is 'GET'.
     */
method:{type:String,value:"GET"},
/**
     * HTTP request headers to send.
     *
     * Example:
     *
     *     <iron-ajax
     *         auto
     *         url="http://somesite.com"
     *         headers='{"X-Requested-With": "XMLHttpRequest"}'
     *         handle-as="json"></iron-ajax>
     *
     * Note: setting a `Content-Type` header here will override the value
     * specified by the `contentType` property of this element.
     */
headers:{type:Object,value:function(){return{}}},
/**
     * Content type to use when sending data. If the `contentType` property
     * is set and a `Content-Type` header is specified in the `headers`
     * property, the `headers` property value will take precedence.
     *
     * Varies the handling of the `body` param.
     */
contentType:{type:String,value:null},
/**
     * Body content to send with the request, typically used with "POST"
     * requests.
     *
     * If body is a string it will be sent unmodified.
     *
     * If Content-Type is set to a value listed below, then
     * the body will be encoded accordingly.
     *
     *    * `content-type="application/json"`
     *      * body is encoded like `{"foo":"bar baz","x":1}`
     *    * `content-type="application/x-www-form-urlencoded"`
     *      * body is encoded like `foo=bar+baz&x=1`
     *
     * Otherwise the body will be passed to the browser unmodified, and it
     * will handle any encoding (e.g. for FormData, Blob, ArrayBuffer).
     *
     * @type
     * (ArrayBuffer|ArrayBufferView|Blob|Document|FormData|null|string|undefined|Object)
     */
body:{type:Object,value:null},
/**
     * Toggle whether XHR is synchronous or asynchronous. Don't change this
     * to true unless You Know What You Are Doing™.
     */
sync:{type:Boolean,value:!1},
/**
     * Specifies what data to store in the `response` property, and
     * to deliver as `event.detail.response` in `response` events.
     *
     * One of:
     *
     *    `text`: uses `XHR.responseText`.
     *
     *    `xml`: uses `XHR.responseXML`.
     *
     *    `json`: uses `XHR.responseText` parsed as JSON.
     *
     *    `arraybuffer`: uses `XHR.response`.
     *
     *    `blob`: uses `XHR.response`.
     *
     *    `document`: uses `XHR.response`.
     */
handleAs:{type:String,value:"json"},
/**
     * Set the withCredentials flag on the request.
     */
withCredentials:{type:Boolean,value:!1},
/**
     * Set the timeout flag on the request.
     */
timeout:{type:Number,value:0},
/**
     * If true, automatically performs an Ajax request when either `url` or
     * `params` changes.
     */
auto:{type:Boolean,value:!1},
/**
     * If true, error messages will automatically be logged to the console.
     */
verbose:{type:Boolean,value:!1},
/**
     * The most recent request made by this iron-ajax element.
     *
     * @type {Object|undefined}
     */
lastRequest:{type:Object,notify:!0,readOnly:!0},
/**
     * The `progress` property of this element's `lastRequest`.
     *
     * @type {Object|undefined}
     */
lastProgress:{type:Object,notify:!0,readOnly:!0},
/**
     * True while lastRequest is in flight.
     */
loading:{type:Boolean,notify:!0,readOnly:!0},
/**
     * lastRequest's response.
     *
     * Note that lastResponse and lastError are set when lastRequest finishes,
     * so if loading is true, then lastResponse and lastError will correspond
     * to the result of the previous request.
     *
     * The type of the response is determined by the value of `handleAs` at
     * the time that the request was generated.
     *
     * @type {Object}
     */
lastResponse:{type:Object,notify:!0,readOnly:!0},
/**
     * lastRequest's error, if any.
     *
     * @type {Object}
     */
lastError:{type:Object,notify:!0,readOnly:!0},
/**
     * An Array of all in-flight requests originating from this iron-ajax
     * element.
     */
activeRequests:{type:Array,notify:!0,readOnly:!0,value:function(){return[]}},
/**
     * Length of time in milliseconds to debounce multiple automatically
     * generated requests.
     */
debounceDuration:{type:Number,value:0,notify:!0},
/**
     * Prefix to be stripped from a JSON response before parsing it.
     *
     * In order to prevent an attack using CSRF with Array responses
     * (http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx/)
     * many backends will mitigate this by prefixing all JSON response bodies
     * with a string that would be nonsensical to a JavaScript parser.
     *
     */
jsonPrefix:{type:String,value:""},
/**
     * By default, iron-ajax's events do not bubble. Setting this attribute will
     * cause its request and response events as well as its iron-ajax-request,
     * -response,  and -error events to bubble to the window object. The vanilla
     * error event never bubbles when using shadow dom even if this.bubbles is
     * true because a scoped flag is not passed with it (first link) and because
     * the shadow dom spec did not used to allow certain events, including
     * events named error, to leak outside of shadow trees (second link).
     * https://www.w3.org/TR/shadow-dom/#scoped-flag
     * https://www.w3.org/TR/2015/WD-shadow-dom-20151215/#events-that-are-not-leaked-into-ancestor-trees
     */
bubbles:{type:Boolean,value:!1},
/**
     * Changes the [`completes`](iron-request#property-completes) promise chain
     * from `generateRequest` to reject with an object
     * containing the original request, as well an error message.
     * If false (default), the promise rejects with an error message only.
     */
rejectWithRequest:{type:Boolean,value:!1},_boundHandleResponse:{type:Function,value:function(){return this._handleResponse.bind(this)}}},observers:["_requestOptionsChanged(url, method, params.*, headers, contentType, body, sync, handleAs, jsonPrefix, withCredentials, timeout, auto)"],created:function(){this._boundOnProgressChanged=this._onProgressChanged.bind(this)},
/**
   * The query string that should be appended to the `url`, serialized from
   * the current value of `params`.
   *
   * @return {string}
   */
get queryString(){var t,e,i=[];for(t in this.params)if(e=this.params[t],t=window.encodeURIComponent(t),Array.isArray(e))for(var s=0;s<e.length;s++)i.push(t+"="+window.encodeURIComponent(e[s]));else null!==e?i.push(t+"="+window.encodeURIComponent(e)):i.push(t);return i.join("&")},
/**
   * The `url` with query string (if `params` are specified), suitable for
   * providing to an `iron-request` instance.
   *
   * @return {string}
   */
get requestUrl(){var t=this.queryString,e=this.url||"";if(t){var i=e.indexOf("?")>=0?"&":"?";return e+i+t}return e},
/**
   * An object that maps header names to header values, first applying the
   * the value of `Content-Type` and then overlaying the headers specified
   * in the `headers` property.
   *
   * @return {Object}
   */
get requestHeaders(){var t,e={},i=this.contentType;if(null==i&&"string"==typeof this.body&&(i="application/x-www-form-urlencoded"),i&&(e["content-type"]=i),"object"==typeof this.headers)for(t in this.headers)e[t]=this.headers[t].toString();return e},_onProgressChanged:function(t){this._setLastProgress(t.detail.value)},
/**
   * Request options suitable for generating an `iron-request` instance based
   * on the current state of the `iron-ajax` instance's properties.
   *
   * @return {{
   *   url: string,
   *   method: (string|undefined),
   *   async: (boolean|undefined),
   *   body:
   * (ArrayBuffer|ArrayBufferView|Blob|Document|FormData|null|string|undefined|Object),
   *   headers: (Object|undefined),
   *   handleAs: (string|undefined),
   *   jsonPrefix: (string|undefined),
   *   withCredentials: (boolean|undefined)}}
   */
toRequestOptions:function(){return{url:this.requestUrl||"",method:this.method,headers:this.requestHeaders,body:this.body,async:!this.sync,handleAs:this.handleAs,jsonPrefix:this.jsonPrefix,withCredentials:this.withCredentials,timeout:this.timeout,rejectWithRequest:this.rejectWithRequest}},
/**
   * Performs an AJAX request to the specified URL.
   *
   * @return {!IronRequestElement}
   */
generateRequest:function(){var t=
/** @type {!IronRequestElement} */
document.createElement("iron-request"),e=this.toRequestOptions();return this.push("activeRequests",t),t.completes.then(this._boundHandleResponse).catch(this._handleError.bind(this,t)).then(this._discardRequest.bind(this,t)),this.fire("iron-ajax-presend",{request:t,options:e},{bubbles:this.bubbles,cancelable:!0}).defaultPrevented?(t.abort(),t.rejectCompletes(t),t):(this.lastRequest&&this.lastRequest.removeEventListener("iron-request-progress-changed",this._boundOnProgressChanged),t.addEventListener("iron-request-progress-changed",this._boundOnProgressChanged),t.send(e),this._setLastProgress(null),this._setLastRequest(t),this._setLoading(!0),this.fire("request",{request:t,options:e},{bubbles:this.bubbles,composed:!0}),this.fire("iron-ajax-request",{request:t,options:e},{bubbles:this.bubbles,composed:!0}),t)},_handleResponse:function(t){t===this.lastRequest&&(this._setLastResponse(t.response),this._setLastError(null),this._setLoading(!1)),this.fire("response",t,{bubbles:this.bubbles,composed:!0}),this.fire("iron-ajax-response",t,{bubbles:this.bubbles,composed:!0})},_handleError:function(t,e){this.verbose&&n.a._error(e),t===this.lastRequest&&(this._setLastError({request:t,error:e,status:t.xhr.status,statusText:t.xhr.statusText,response:t.xhr.response}),this._setLastResponse(null),this._setLoading(!1)),// Tests fail if this goes after the normal this.fire('error', ...)
this.fire("iron-ajax-error",{request:t,error:e},{bubbles:this.bubbles,composed:!0}),this.fire("error",{request:t,error:e},{bubbles:this.bubbles,composed:!0})},_discardRequest:function(t){var e=this.activeRequests.indexOf(t);e>-1&&this.splice("activeRequests",e,1)},_requestOptionsChanged:function(){this.debounce("generate-request",(function(){null!=this.url&&this.auto&&this.generateRequest()}),this.debounceDuration)}})},
/***/ZXRe:
/***/function(t,e,i){"use strict";
/* harmony import */i("pYlh");
/* harmony import */var s=i("78gc"),n=i("qEMp");
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/**
`iron-a11y-keys` provides a cross-browser interface for processing
keyboard commands. The interface adheres to [WAI-ARIA best
practices](http://www.w3.org/TR/wai-aria-practices/#kbd_general_binding).
It uses an expressive syntax to filter key presses.

## Basic usage

The sample code below is a portion of a custom element. The goal is to call
the `onEnter` method whenever the `paper-input` element is in focus and
the `Enter` key is pressed.

    <iron-a11y-keys id="a11y" target="[[target]]" keys="enter"
                        on-keys-pressed="onEnter"></iron-a11y-keys>
    <paper-input id="input"
                 placeholder="Type something. Press enter. Check console."
                 value="{{userInput::input}}"></paper-input>

The custom element declares an `iron-a11y-keys` element that is bound to a
property called `target`. The `target` property
needs to evaluate to the `paper-input` node. `iron-a11y-keys` registers
an event handler for the target node using Polymer's [annotated event handler
syntax](https://www.polymer-project.org/1.0/docs/devguide/events.html#annotated-listeners).
`{{userInput::input}}` sets the `userInput` property to the user's input on each
keystroke.

The last step is to link the two elements within the custom element's
registration.

    ...
    properties: {
      userInput: {
        type: String,
        notify: true,
      },
      target: {
        type: Object,
        value: function() {
          return this.$.input;
        }
      },
    },
    onEnter: function() {
      console.log(this.userInput);
    }
    ...

## The `keys` attribute

The `keys` attribute expresses what combination of keys triggers the event.

The attribute accepts a space-separated, plus-sign-concatenated
set of modifier keys and some common keyboard keys.

The common keys are: `a-z`, `0-9` (top row and number pad), `*` (shift 8 and
number pad), `F1-F12`, `Page Up`, `Page Down`, `Left Arrow`, `Right Arrow`,
`Down Arrow`, `Up Arrow`, `Home`, `End`, `Escape`, `Space`, `Tab`, `Enter`.

The modifier keys are: `Shift`, `Control`, `Alt`, `Meta`.

All keys are expected to be lowercase and shortened. E.g.
`Left Arrow` is `left`, `Page Down` is `pagedown`, `Control` is `ctrl`,
`F1` is `f1`, `Escape` is `esc`, etc.

### Grammar

Below is the
[EBNF](http://en.wikipedia.org/wiki/Extended_Backus%E2%80%93Naur_Form) Grammar
of the `keys` attribute.

    modifier = "shift" | "ctrl" | "alt" | "meta";
    ascii = ? /[a-z0-9]/ ? ;
    fnkey = ? f1 through f12 ? ;
    arrow = "up" | "down" | "left" | "right" ;
    key = "tab" | "esc" | "space" | "*" | "pageup" | "pagedown" |
          "home" | "end" | arrow | ascii | fnkey;
    event = "keypress" | "keydown" | "keyup";
    keycombo = { modifier, "+" }, key, [ ":", event ] ;
    keys = keycombo, { " ", keycombo } ;

### Example

Given the following value for `keys`:

`ctrl+shift+f7 up pagedown esc space alt+m`

The event is fired if any of the following key combinations are fired:
`Control` and `Shift` and `F7` keys, `Up Arrow` key, `Page Down` key,
`Escape` key, `Space` key, `Alt` and `M` keys.

### WAI-ARIA Slider Example

The following is an example of the set of keys that fulfills WAI-ARIA's
"slider" role [best
practices](http://www.w3.org/TR/wai-aria-practices/#slider):

    <iron-a11y-keys target="[[target]]" keys="left pagedown down"
                    on-keys-pressed="decrement"></iron-a11y-keys>
    <iron-a11y-keys target="[[target]]" keys="right pageup up"
                    on-keys-pressed="increment"></iron-a11y-keys>
    <iron-a11y-keys target="[[target]]" keys="home"
                    on-keys-pressed="setMin"></iron-a11y-keys>
    <iron-a11y-keys target="[[target]]" keys="end"
                    on-keys-pressed="setMax"></iron-a11y-keys>

The `target` properties must evaluate to a node. See the basic usage
example above.

Each of the values for the `on-keys-pressed` attributes must evalute
to methods. The `increment` method should move the slider a set amount
toward the maximum value. `decrement` should move the slider a set amount
toward the minimum value. `setMin` should move the slider to the minimum
value. `setMax` should move the slider to the maximum value.

@demo demo/index.html
*/
Object(n.a)({is:"iron-a11y-keys",behaviors:[s.a],properties:{
/** @type {?Node} */
target:{type:Object,observer:"_targetChanged"},
/**
     * Space delimited list of keys where each key follows the format:
     * `[MODIFIER+]*KEY[:EVENT]`.
     * e.g. `keys="space ctrl+shift+tab enter:keyup"`.
     * More detail can be found in the "Grammar" section of the documentation
     */
keys:{type:String,reflectToAttribute:!0,observer:"_keysChanged"}},attached:function(){this.target||(this.target=this.parentNode)},_targetChanged:function(t){this.keyEventTarget=t},_keysChanged:function(){this.removeOwnKeyBindings(),this.addOwnKeyBinding(this.keys,"_fireKeysPressed")},_fireKeysPressed:function(t){this.fire("keys-pressed",t.detail,{})}})},
/***/e0ld:
/***/function(t,e,i){"use strict";
/* harmony import */i("pYlh");
/* harmony import */var s=i("1DlD"),n=i("qEMp"),o=i("hvZu");
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/**
 * The `iron-iconset-svg` element allows users to define their own icon sets
 * that contain svg icons. The svg icon elements should be children of the
 * `iron-iconset-svg` element. Multiple icons should be given distinct id's.
 *
 * Using svg elements to create icons has a few advantages over traditional
 * bitmap graphics like jpg or png. Icons that use svg are vector based so
 * they are resolution independent and should look good on any device. They
 * are stylable via css. Icons can be themed, colorized, and even animated.
 *
 * Example:
 *
 *     <iron-iconset-svg name="my-svg-icons" size="24">
 *       <svg>
 *         <defs>
 *           <g id="shape">
 *             <rect x="12" y="0" width="12" height="24" />
 *             <circle cx="12" cy="12" r="12" />
 *           </g>
 *         </defs>
 *       </svg>
 *     </iron-iconset-svg>
 *
 * This will automatically register the icon set "my-svg-icons" to the iconset
 * database.  To use these icons from within another element, make a
 * `iron-iconset` element and call the `byId` method
 * to retrieve a given iconset. To apply a particular icon inside an
 * element use the `applyIcon` method. For example:
 *
 *     iconset.applyIcon(iconNode, 'car');
 *
 * @element iron-iconset-svg
 * @demo demo/index.html
 * @implements {Polymer.Iconset}
 */
Object(n.a)({is:"iron-iconset-svg",properties:{
/**
     * The name of the iconset.
     */
name:{type:String,observer:"_nameChanged"},
/**
     * The size of an individual icon. Note that icons must be square.
     */
size:{type:Number,value:24},
/**
     * Set to true to enable mirroring of icons where specified when they are
     * stamped. Icons that should be mirrored should be decorated with a
     * `mirror-in-rtl` attribute.
     *
     * NOTE: For performance reasons, direction will be resolved once per
     * document per iconset, so moving icons in and out of RTL subtrees will
     * not cause their mirrored state to change.
     */
rtlMirroring:{type:Boolean,value:!1},
/**
     * Set to true to measure RTL based on the dir attribute on the body or
     * html elements (measured on document.body or document.documentElement as
     * available).
     */
useGlobalRtlAttribute:{type:Boolean,value:!1}},created:function(){this._meta=new s.a({type:"iconset",key:null,value:null})},attached:function(){this.style.display="none"},
/**
   * Construct an array of all icon names in this iconset.
   *
   * @return {!Array} Array of icon names.
   */
getIconNames:function(){return this._icons=this._createIconMap(),Object.keys(this._icons).map((function(t){return this.name+":"+t}),this)},
/**
   * Applies an icon to the given element.
   *
   * An svg icon is prepended to the element's shadowRoot if it exists,
   * otherwise to the element itself.
   *
   * If RTL mirroring is enabled, and the icon is marked to be mirrored in
   * RTL, the element will be tested (once and only once ever for each
   * iconset) to determine the direction of the subtree the element is in.
   * This direction will apply to all future icon applications, although only
   * icons marked to be mirrored will be affected.
   *
   * @method applyIcon
   * @param {Element} element Element to which the icon is applied.
   * @param {string} iconName Name of the icon to apply.
   * @return {?Element} The svg element which renders the icon.
   */
applyIcon:function(t,e){
// Remove old svg element
this.removeIcon(t);// install new svg element
var i=this._cloneIcon(e,this.rtlMirroring&&this._targetIsRTL(t));if(i){
// insert svg element into shadow root, if it exists
var s=Object(o.a)(t.root||t);return s.insertBefore(i,s.childNodes[0]),t._svgIcon=i}return null},
/**
   * Remove an icon from the given element by undoing the changes effected
   * by `applyIcon`.
   *
   * @param {Element} element The element from which the icon is removed.
   */
removeIcon:function(t){
// Remove old svg element
t._svgIcon&&(Object(o.a)(t.root||t).removeChild(t._svgIcon),t._svgIcon=null)},
/**
   * Measures and memoizes the direction of the element. Note that this
   * measurement is only done once and the result is memoized for future
   * invocations.
   */
_targetIsRTL:function(t){if(null==this.__targetIsRTL)if(this.useGlobalRtlAttribute){var e=document.body&&document.body.hasAttribute("dir")?document.body:document.documentElement;this.__targetIsRTL="rtl"===e.getAttribute("dir")}else t&&t.nodeType!==Node.ELEMENT_NODE&&(t=t.host),this.__targetIsRTL=t&&"rtl"===window.getComputedStyle(t).direction;return this.__targetIsRTL},
/**
   *
   * When name is changed, register iconset metadata
   *
   */
_nameChanged:function(){this._meta.value=null,this._meta.key=this.name,this._meta.value=this,this.async((function(){this.fire("iron-iconset-added",this,{node:window})}))},
/**
   * Create a map of child SVG elements by id.
   *
   * @return {!Object} Map of id's to SVG elements.
   */
_createIconMap:function(){
// Objects chained to Object.prototype (`{}`) have members. Specifically,
// on FF there is a `watch` method that confuses the icon map, so we
// need to use a null-based object here.
var t=Object.create(null);return Object(o.a)(this).querySelectorAll("[id]").forEach((function(e){t[e.id]=e})),t},
/**
   * Produce installable clone of the SVG element matching `id` in this
   * iconset, or `undefined` if there is no matching element.
   *
   * @return {Element} Returns an installable clone of the SVG element
   * matching `id`.
   */
_cloneIcon:function(t,e){
// create the icon map on-demand, since the iconset itself has no discrete
// signal to know when it's children are fully parsed
return this._icons=this._icons||this._createIconMap(),this._prepareSvgClone(this._icons[t],this.size,e)},
/**
   * @param {Element} sourceSvg
   * @param {number} size
   * @param {Boolean} mirrorAllowed
   * @return {Element}
   */
_prepareSvgClone:function(t,e,i){if(t){var s=t.cloneNode(!0),n=document.createElementNS("http://www.w3.org/2000/svg","svg"),o=s.getAttribute("viewBox")||"0 0 "+e+" "+e,r="pointer-events: none; display: block; width: 100%; height: 100%;";return i&&s.hasAttribute("mirror-in-rtl")&&(r+="-webkit-transform:scale(-1,1);transform:scale(-1,1);transform-origin:center;"),n.setAttribute("viewBox",o),n.setAttribute("preserveAspectRatio","xMidYMid meet"),n.setAttribute("focusable","false"),// TODO(dfreedm): `pointer-events: none` works around
// https://crbug.com/370136
// TODO(sjmiles): inline style may not be ideal, but avoids requiring a
// shadow-root
n.style.cssText=r,n.appendChild(s).removeAttribute("id"),n}return null}})},
/***/kpqP:
/***/function(t,e,i){"use strict";
/* harmony import */i("pYlh"),i("78gc")
/* harmony import */;var s=i("JxY1"),n=i("uo8t"),o=i("aUK7"),r=i("qEMp"),a=i("hvZu"),l=i("HtFd"),h=i("Y40L"),c=i("9nmN"),u=i("WE4f"),d=i("o5Wi"),f=i("tZcj"),_=(i("LDKE"),navigator.userAgent.match(/iP(?:hone|ad;(?: U;)? CPU) OS (\d+)/)),p=_&&_[1]>=8;
/**

`iron-list` displays a virtual, 'infinite' list. The template inside
the iron-list element represents the DOM to create for each list item.
The `items` property specifies an array of list item data.

For performance reasons, not every item in the list is rendered at once;
instead a small subset of actual template elements *(enough to fill the
viewport)* are rendered and reused as the user scrolls. As such, it is important
that all state of the list template is bound to the model driving it, since the
view may be reused with a new model at any time. Particularly, any state that
may change as the result of a user interaction with the list item must be bound
to the model to avoid view state inconsistency.

### Sizing iron-list

`iron-list` must either be explicitly sized, or delegate scrolling to an
explicitly sized parent. By "explicitly sized", we mean it either has an
explicit CSS `height` property set via a class or inline style, or else is sized
by other layout means (e.g. the `flex` or `fit` classes).

#### Flexbox - [jsbin](https://jsbin.com/vejoni/edit?html,output)

```html
<template is="x-list">
  <style>
    :host {
      display: block;
      height: 100vh;
      display: flex;
      flex-direction: column;
    }

    iron-list {
      flex: 1 1 auto;
    }
  </style>
  <app-toolbar>App name</app-toolbar>
  <iron-list items="[[items]]">
    <template>
      <div>
        ...
      </div>
    </template>
  </iron-list>
</template>
```
#### Explicit size - [jsbin](https://jsbin.com/vopucus/edit?html,output)
```html
<template is="x-list">
  <style>
    :host {
      display: block;
    }

    iron-list {
      height: 100vh; /* don't use % values unless the parent element is sized.
*\/
    }
  </style>
  <iron-list items="[[items]]">
    <template>
      <div>
        ...
      </div>
    </template>
  </iron-list>
</template>
```
#### Main document scrolling -
[jsbin](https://jsbin.com/wevirow/edit?html,output)
```html
<head>
  <style>
    body {
      height: 100vh;
      margin: 0;
      display: flex;
      flex-direction: column;
    }

    app-toolbar {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
    }

    iron-list {
      /* add padding since the app-toolbar is fixed at the top *\/
      padding-top: 64px;
    }
  </style>
</head>
<body>
  <app-toolbar>App name</app-toolbar>
  <iron-list scroll-target="document">
    <template>
      <div>
        ...
      </div>
    </template>
  </iron-list>
</body>
```

`iron-list` must be given a `<template>` which contains exactly one element. In
the examples above we used a `<div>`, but you can provide any element (including
custom elements).

### Template model

List item templates should bind to template models of the following structure:

```js
{
  index: 0,        // index in the item array
  selected: false, // true if the current item is selected
  tabIndex: -1,    // a dynamically generated tabIndex for focus management
  item: {}         // user data corresponding to items[index]
}
```

Alternatively, you can change the property name used as data index by changing
the `indexAs` property. The `as` property defines the name of the variable to
add to the binding scope for the array.

For example, given the following `data` array:

##### data.json

```js
[
  {"name": "Bob"},
  {"name": "Tim"},
  {"name": "Mike"}
]
```

The following code would render the list (note the name property is bound from
the model object provided to the template scope):

```html
<iron-ajax url="data.json" last-response="{{data}}" auto></iron-ajax>
<iron-list items="[[data]]" as="item">
  <template>
    <div>
      Name: [[item.name]]
    </div>
  </template>
</iron-list>
```

### Grid layout

`iron-list` supports a grid layout in addition to linear layout by setting
the `grid` attribute.  In this case, the list template item must have both fixed
width and height (e.g. via CSS). Based on this, the number of items
per row are determined automatically based on the size of the list viewport.

### Accessibility

`iron-list` automatically manages the focus state for the items. It also
provides a `tabIndex` property within the template scope that can be used for
keyboard navigation. For example, users can press the up and down keys to move
to previous and next items in the list:

```html
<iron-list items="[[data]]" as="item">
  <template>
    <div tabindex$="[[tabIndex]]">
      Name: [[item.name]]
    </div>
  </template>
</iron-list>
```

### Styling

You can use the `--iron-list-items-container` mixin to style the container of
items:

```css
iron-list {
 --iron-list-items-container: {
    margin: auto;
  };
}
```

### Resizing

`iron-list` lays out the items when it receives a notification via the
`iron-resize` event. This event is fired by any element that implements
`IronResizableBehavior`.

By default, elements such as `iron-pages`, `paper-tabs` or `paper-dialog` will
trigger this event automatically. If you hide the list manually (e.g. you use
`display: none`) you might want to implement `IronResizableBehavior` or fire
this event manually right after the list became visible again. For example:

```js
document.querySelector('iron-list').fire('iron-resize');
```

### When should `<iron-list>` be used?

`iron-list` should be used when a page has significantly more DOM nodes than the
ones visible on the screen. e.g. the page has 500 nodes, but only 20 are visible
at a time. This is why we refer to it as a `virtual` list. In this case, a
`dom-repeat` will still create 500 nodes which could slow down the web app, but
`iron-list` will only create 20.

However, having an `iron-list` does not mean that you can load all the data at
once. Say you have a million records in the database, you want to split the data
into pages so you can bring in a page at the time. The page could contain 500
items, and iron-list will only render 20.

@element iron-list
@demo demo/index.html

*/
Object(r.a)({
/** @override */
_template:d.a`<style>:host{display:block}@media only screen and (-webkit-max-device-pixel-ratio:1){:host{will-change:transform}}#items{@apply --iron-list-items-container;position:relative}:host(:not([grid])) #items>::slotted(*){width:100%}#items>::slotted(*){box-sizing:border-box;margin:0;position:absolute;top:0;will-change:transform}</style><array-selector id="selector" items="{{items}}" selected="{{selectedItems}}" selected-item="{{selectedItem}}"></array-selector><div id="items"><slot></slot></div>`,is:"iron-list",properties:{
/**
     * An array containing items determining how many instances of the template
     * to stamp and that that each template instance should bind to.
     */
items:{type:Array},
/**
     * The name of the variable to add to the binding scope for the array
     * element associated with a given template instance.
     */
as:{type:String,value:"item"},
/**
     * The name of the variable to add to the binding scope with the index
     * for the row.
     */
indexAs:{type:String,value:"index"},
/**
     * The name of the variable to add to the binding scope to indicate
     * if the row is selected.
     */
selectedAs:{type:String,value:"selected"},
/**
     * When true, the list is rendered as a grid. Grid items must have
     * fixed width and height set via CSS. e.g.
     *
     * ```html
     * <iron-list grid>
     *   <template>
     *      <div style="width: 100px; height: 100px;"> 100x100 </div>
     *   </template>
     * </iron-list>
     * ```
     */
grid:{type:Boolean,value:!1,reflectToAttribute:!0,observer:"_gridChanged"},
/**
     * When true, tapping a row will select the item, placing its data model
     * in the set of selected items retrievable via the selection property.
     *
     * Note that tapping focusable elements within the list item will not
     * result in selection, since they are presumed to have their * own action.
     */
selectionEnabled:{type:Boolean,value:!1},
/**
     * When `multiSelection` is false, this is the currently selected item, or
     * `null` if no item is selected.
     */
selectedItem:{type:Object,notify:!0},
/**
     * When `multiSelection` is true, this is an array that contains the
     * selected items.
     */
selectedItems:{type:Object,notify:!0},
/**
     * When `true`, multiple items may be selected at once (in this case,
     * `selected` is an array of currently selected items).  When `false`,
     * only one item may be selected at a time.
     */
multiSelection:{type:Boolean,value:!1},
/**
     * The offset top from the scrolling element to the iron-list element.
     * This value can be computed using the position returned by
     * `getBoundingClientRect()` although it's preferred to use a constant value
     * when possible.
     *
     * This property is useful when an external scrolling element is used and
     * there's some offset between the scrolling element and the list. For
     * example: a header is placed above the list.
     */
scrollOffset:{type:Number,value:0}},observers:["_itemsChanged(items.*)","_selectionEnabledChanged(selectionEnabled)","_multiSelectionChanged(multiSelection)","_setOverflow(scrollTarget, scrollOffset)"],behaviors:[l.a,s.a,n.a,o.a],
/**
   * The ratio of hidden tiles that should remain in the scroll direction.
   * Recommended value ~0.5, so it will distribute tiles evenly in both
   * directions.
   */
_ratio:.5,
/**
   * The padding-top value for the list.
   */
_scrollerPaddingTop:0,
/**
   * This value is a cached value of `scrollTop` from the last `scroll` event.
   */
_scrollPosition:0,
/**
   * The sum of the heights of all the tiles in the DOM.
   */
_physicalSize:0,
/**
   * The average `offsetHeight` of the tiles observed till now.
   */
_physicalAverage:0,
/**
   * The number of tiles which `offsetHeight` > 0 observed until now.
   */
_physicalAverageCount:0,
/**
   * The Y position of the item rendered in the `_physicalStart`
   * tile relative to the scrolling list.
   */
_physicalTop:0,
/**
   * The number of items in the list.
   */
_virtualCount:0,
/**
   * The estimated scroll height based on `_physicalAverage`
   */
_estScrollHeight:0,
/**
   * The scroll height of the dom node
   */
_scrollHeight:0,
/**
   * The height of the list. This is referred as the viewport in the context of
   * list.
   */
_viewportHeight:0,
/**
   * The width of the list. This is referred as the viewport in the context of
   * list.
   */
_viewportWidth:0,
/**
   * An array of DOM nodes that are currently in the tree
   * @type {?Array<!HTMLElement>}
   */
_physicalItems:null,
/**
   * An array of heights for each item in `_physicalItems`
   * @type {?Array<number>}
   */
_physicalSizes:null,
/**
   * A cached value for the first visible index.
   * See `firstVisibleIndex`
   * @type {?number}
   */
_firstVisibleIndexVal:null,
/**
   * A cached value for the last visible index.
   * See `lastVisibleIndex`
   * @type {?number}
   */
_lastVisibleIndexVal:null,
/**
   * The max number of pages to render. One page is equivalent to the height of
   * the list.
   */
_maxPages:2,
/**
   * The currently focused physical item.
   */
_focusedItem:null,
/**
   * The virtual index of the focused item.
   */
_focusedVirtualIndex:-1,
/**
   * The physical index of the focused item.
   */
_focusedPhysicalIndex:-1,
/**
   * The the item that is focused if it is moved offscreen.
   * @private {?HTMLElement}
   */
_offscreenFocusedItem:null,
/**
   * The item that backfills the `_offscreenFocusedItem` in the physical items
   * list when that item is moved offscreen.
   * @type {?HTMLElement}
   */
_focusBackfillItem:null,
/**
   * The maximum items per row
   */
_itemsPerRow:1,
/**
   * The width of each grid item
   */
_itemWidth:0,
/**
   * The height of the row in grid layout.
   */
_rowHeight:0,
/**
   * The cost of stamping a template in ms.
   */
_templateCost:0,
/**
   * Needed to pass event.model property to declarative event handlers -
   * see polymer/polymer#4339.
   */
_parentModel:!0,
/**
   * The bottom of the physical content.
   */
get _physicalBottom(){return this._physicalTop+this._physicalSize},
/**
   * The bottom of the scroll.
   */
get _scrollBottom(){return this._scrollPosition+this._viewportHeight},
/**
   * The n-th item rendered in the last physical item.
   */
get _virtualEnd(){return this._virtualStart+this._physicalCount-1},
/**
   * The height of the physical content that isn't on the screen.
   */
get _hiddenContentSize(){return(this.grid?this._physicalRows*this._rowHeight:this._physicalSize)-this._viewportHeight},
/**
   * The parent node for the _userTemplate.
   */
get _itemsParent(){return Object(a.a)(Object(a.a)(this._userTemplate).parentNode)},
/**
   * The maximum scroll top value.
   */
get _maxScrollTop(){return this._estScrollHeight-this._viewportHeight+this._scrollOffset},
/**
   * The largest n-th value for an item such that it can be rendered in
   * `_physicalStart`.
   */
get _maxVirtualStart(){var t=this._convertIndexToCompleteRow(this._virtualCount);return Math.max(0,t-this._physicalCount)},set _virtualStart(t){t=this._clamp(t,0,this._maxVirtualStart),this.grid&&(t-=t%this._itemsPerRow),this._virtualStartVal=t},get _virtualStart(){return this._virtualStartVal||0},
/**
   * The k-th tile that is at the top of the scrolling list.
   */
set _physicalStart(t){(t%=this._physicalCount)<0&&(t=this._physicalCount+t),this.grid&&(t-=t%this._itemsPerRow),this._physicalStartVal=t},get _physicalStart(){return this._physicalStartVal||0},
/**
   * The k-th tile that is at the bottom of the scrolling list.
   */
get _physicalEnd(){return(this._physicalStart+this._physicalCount-1)%this._physicalCount},set _physicalCount(t){this._physicalCountVal=t},get _physicalCount(){return this._physicalCountVal||0},
/**
   * An optimal physical size such that we will have enough physical items
   * to fill up the viewport and recycle when the user scrolls.
   *
   * This default value assumes that we will at least have the equivalent
   * to a viewport of physical items above and below the user's viewport.
   */
get _optPhysicalSize(){return 0===this._viewportHeight?1/0:this._viewportHeight*this._maxPages},
/**
   * True if the current list is visible.
   */
get _isVisible(){return Boolean(this.offsetWidth||this.offsetHeight)},
/**
   * Gets the index of the first visible item in the viewport.
   *
   * @type {number}
   */
get firstVisibleIndex(){var t=this._firstVisibleIndexVal;if(null==t){var e=this._physicalTop+this._scrollOffset;t=this._iterateItems((function(t,i){return(e+=this._getPhysicalSizeIncrement(t))>this._scrollPosition?this.grid?i-i%this._itemsPerRow:i:// Handle a partially rendered final row in grid mode
this.grid&&this._virtualCount-1===i?i-i%this._itemsPerRow:void 0}))||0,this._firstVisibleIndexVal=t}return t},
/**
   * Gets the index of the last visible item in the viewport.
   *
   * @type {number}
   */
get lastVisibleIndex(){var t=this._lastVisibleIndexVal;if(null==t){if(this.grid)t=Math.min(this._virtualCount,this.firstVisibleIndex+this._estRowsInView*this._itemsPerRow-1);else{var e=this._physicalTop+this._scrollOffset;this._iterateItems((function(i,s){e<this._scrollBottom&&(t=s),e+=this._getPhysicalSizeIncrement(i)}))}this._lastVisibleIndexVal=t}return t},get _defaultScrollTarget(){return this},get _virtualRowCount(){return Math.ceil(this._virtualCount/this._itemsPerRow)},get _estRowsInView(){return Math.ceil(this._viewportHeight/this._rowHeight)},get _physicalRows(){return Math.ceil(this._physicalCount/this._itemsPerRow)},get _scrollOffset(){return this._scrollerPaddingTop+this.scrollOffset},
/** @override */
ready:function(){this.addEventListener("focus",this._didFocus.bind(this),!0)},
/** @override */
attached:function(){this._debounce("_render",this._render,h.a),// `iron-resize` is fired when the list is attached if the event is added
// before attached causing unnecessary work.
this.listen(this,"iron-resize","_resizeHandler"),this.listen(this,"keydown","_keydownHandler")},
/** @override */
detached:function(){this.unlisten(this,"iron-resize","_resizeHandler"),this.unlisten(this,"keydown","_keydownHandler")},
/**
   * Set the overflow property if this element has its own scrolling region
   */
_setOverflow:function(t){this.style.webkitOverflowScrolling=t===this?"touch":"",this.style.overflowY=t===this?"auto":"",// Clear cache.
this._lastVisibleIndexVal=null,this._firstVisibleIndexVal=null,this._debounce("_render",this._render,h.a)},
/**
   * Invoke this method if you dynamically update the viewport's
   * size or CSS padding.
   *
   * @method updateViewportBoundaries
   */
updateViewportBoundaries:function(){var t=window.getComputedStyle(this);this._scrollerPaddingTop=this.scrollTarget===this?0:parseInt(t["padding-top"],10),this._isRTL=Boolean("rtl"===t.direction),this._viewportWidth=this.$.items.offsetWidth,this._viewportHeight=this._scrollTargetHeight,this.grid&&this._updateGridMetrics()},
/**
   * Recycles the physical items when needed.
   */
_scrollHandler:function(){var t=Math.max(0,Math.min(this._maxScrollTop,this._scrollTop)),e=t-this._scrollPosition,i=e>=0;// Random access.
if(// Track the current scroll position.
this._scrollPosition=t,// Clear indexes for first and last visible indexes.
this._firstVisibleIndexVal=null,this._lastVisibleIndexVal=null,Math.abs(e)>this._physicalSize&&this._physicalSize>0){e-=this._scrollOffset;var s=Math.round(e/this._physicalAverage)*this._itemsPerRow;this._virtualStart=this._virtualStart+s,this._physicalStart=this._physicalStart+s,// Estimate new physical offset based on the virtual start index.
// adjusts the physical start position to stay in sync with the clamped
// virtual start index. It's critical not to let this value be
// more than the scroll position however, since that would result in
// the physical items not covering the viewport, and leading to
// _increasePoolIfNeeded to run away creating items to try to fill it.
this._physicalTop=Math.min(Math.floor(this._virtualStart/this._itemsPerRow)*this._physicalAverage,this._scrollPosition),this._update()}else if(this._physicalCount>0){var n=this._getReusables(i);i?(this._physicalTop=n.physicalTop,this._virtualStart=this._virtualStart+n.indexes.length,this._physicalStart=this._physicalStart+n.indexes.length):(this._virtualStart=this._virtualStart-n.indexes.length,this._physicalStart=this._physicalStart-n.indexes.length),this._update(n.indexes,i?null:n.indexes),this._debounce("_increasePoolIfNeeded",this._increasePoolIfNeeded.bind(this,0),h.c)}},
/**
   * Returns an object that contains the indexes of the physical items
   * that might be reused and the physicalTop.
   *
   * @param {boolean} fromTop If the potential reusable items are above the scrolling region.
   */
_getReusables:function(t){var e,i,s,n=[],o=this._hiddenContentSize*this._ratio,r=this._virtualStart,a=this._virtualEnd,l=this._physicalCount,h=this._physicalTop+this._scrollOffset,c=this._physicalBottom+this._scrollOffset,u=this._scrollPosition,d=this._scrollBottom;for(t?(e=this._physicalStart,this._physicalEnd,i=u-h):(e=this._physicalEnd,this._physicalStart,i=c-d);i-=s=this._getPhysicalSizeIncrement(e),!(n.length>=l||i<=o);)if(t){
// Check that index is within the valid range.
if(a+n.length+1>=this._virtualCount)break;// Check that the index is not visible.
if(h+s>=u-this._scrollOffset)break;n.push(e),h+=s,e=(e+1)%l}else{
// Check that index is within the valid range.
if(r-n.length<=0)break;// Check that the index is not visible.
if(h+this._physicalSize-s<=d)break;n.push(e),h-=s,e=0===e?l-1:e-1}return{indexes:n,physicalTop:h-this._scrollOffset}},
/**
   * Update the list of items, starting from the `_virtualStart` item.
   * @param {!Array<number>=} itemSet
   * @param {!Array<number>=} movingUp
   */
_update:function(t,e){if(!(t&&0===t.length||0===this._physicalCount)){// Adjust offset after measuring.
if(this._manageFocus(),this._assignModels(t),this._updateMetrics(t),e)for(;e.length;){var i=e.pop();this._physicalTop-=this._getPhysicalSizeIncrement(i)}this._positionItems(),this._updateScrollerSize()}},
/**
   * Creates a pool of DOM elements and attaches them to the local dom.
   *
   * @param {number} size Size of the pool
   */
_createPool:function(t){var e,i;this._ensureTemplatized();var s=new Array(t);for(e=0;e<t;e++)i=this.stamp(null),// TODO(blasten):
// First element child is item; Safari doesn't support children[0]
// on a doc fragment. Test this to see if it still matters.
s[e]=i.root.querySelector("*"),this._itemsParent.appendChild(i.root);return s},_isClientFull:function(){return 0!=this._scrollBottom&&this._physicalBottom-1>=this._scrollBottom&&this._physicalTop<=this._scrollPosition},
/**
   * Increases the pool size.
   */
_increasePoolIfNeeded:function(t){var e=this._clamp(this._physicalCount+t,3,this._virtualCount-this._virtualStart);if(e=this._convertIndexToCompleteRow(e),this.grid){var i=e%this._itemsPerRow;i&&e-i<=this._physicalCount&&(e+=this._itemsPerRow),e-=i}var s=e-this._physicalCount,n=Math.round(.5*this._physicalCount);if(!(s<0)){if(s>0){var o=window.performance.now();// Concat arrays in place.
[].push.apply(this._physicalItems,this._createPool(s));// Push 0s into physicalSizes. Can't use Array.fill because IE11 doesn't
// support it.
for(var r=0;r<s;r++)this._physicalSizes.push(0);this._physicalCount=this._physicalCount+s,// Update the physical start if it needs to preserve the model of the
// focused item. In this situation, the focused item is currently rendered
// and its model would have changed after increasing the pool if the
// physical start remained unchanged.
this._physicalStart>this._physicalEnd&&this._isIndexRendered(this._focusedVirtualIndex)&&this._getPhysicalIndex(this._focusedVirtualIndex)<this._physicalEnd&&(this._physicalStart=this._physicalStart+s),this._update(),this._templateCost=(window.performance.now()-o)/s,n=Math.round(.5*this._physicalCount)}// The upper bounds is not fixed when dealing with a grid that doesn't
// fill it's last row with the exact number of items per row.
this._virtualEnd>=this._virtualCount-1||0===n||(this._isClientFull()?this._physicalSize<this._optPhysicalSize&&
// Yield and increase the pool during idle time until the physical size is
// optimal.
this._debounce("_increasePoolIfNeeded",this._increasePoolIfNeeded.bind(this,this._clamp(Math.round(50/this._templateCost),1,n)),h.b):this._debounce("_increasePoolIfNeeded",this._increasePoolIfNeeded.bind(this,n),h.c))}},
/**
   * Renders the a new list.
   */
_render:function(){if(this.isAttached&&this._isVisible)if(0!==this._physicalCount){var t=this._getReusables(!0);this._physicalTop=t.physicalTop,this._virtualStart=this._virtualStart+t.indexes.length,this._physicalStart=this._physicalStart+t.indexes.length,this._update(t.indexes),this._update(),this._increasePoolIfNeeded(0)}else this._virtualCount>0&&(
// Initial render
this.updateViewportBoundaries(),this._increasePoolIfNeeded(3))},
/**
   * Templetizes the user template.
   */
_ensureTemplatized:function(){if(!this.ctor){this._userTemplate=
/** @type {!HTMLTemplateElement} */
this.queryEffectiveChildren("template"),this._userTemplate||console.warn("iron-list requires a template to be provided in light-dom");var t={__key__:!0};t[this.as]=!0,t[this.indexAs]=!0,t[this.selectedAs]=!0,t.tabIndex=!0,this._instanceProps=t,this.templatize(this._userTemplate,this.mutableData)}},_gridChanged:function(t,e){void 0!==e&&(this.notifyResize(),Object(u.b)(),t&&this._updateGridMetrics())},
/**
   * Called when the items have changed. That is, reassignments
   * to `items`, splices or updates to a single item.
   */
_itemsChanged:function(t){if("items"===t.path)this._virtualStart=0,this._physicalTop=0,this._virtualCount=this.items?this.items.length:0,this._physicalIndexForKey={},this._firstVisibleIndexVal=null,this._lastVisibleIndexVal=null,this._physicalCount=this._physicalCount||0,this._physicalItems=this._physicalItems||[],this._physicalSizes=this._physicalSizes||[],this._physicalStart=0,this._scrollTop>this._scrollOffset&&this._resetScrollPosition(0),this._removeFocusedItem(),this._debounce("_render",this._render,h.a);else if("items.splices"===t.path){if(this._adjustVirtualIndex(t.value.indexSplices),this._virtualCount=this.items?this.items.length:0,t.value.indexSplices.some((function(t){return t.addedCount>0||t.removed.length>0}))){
// Only blur activeElement if it is a descendant of the list (#505,
// #507).
var e=this._getActiveElement();this.contains(e)&&e.blur()}// Render only if the affected index is rendered.
var i=t.value.indexSplices.some((function(t){return t.index+t.addedCount>=this._virtualStart&&t.index<=this._virtualEnd}),this);this._isClientFull()&&!i||this._debounce("_render",this._render,h.a)}else"items.length"!==t.path&&this._forwardItemPath(t.path,t.value)},_forwardItemPath:function(t,e){// 'items.'.length == 6
var i,s,n,o=(t=t.slice(6)).indexOf(".");-1===o&&(o=t.length);var r=this.modelForElement(this._offscreenFocusedItem),a=parseInt(t.substring(0,o),10);(i=this._isIndexRendered(a))?(s=this._getPhysicalIndex(a),n=this.modelForElement(this._physicalItems[s])):r&&(n=r),n&&n[this.indexAs]===a&&(t=t.substring(o+1),t=this.as+(t?"."+t:""),n._setPendingPropertyOrPath(t,e,!1,!0),n._flushProperties&&n._flushProperties(),// TODO(blasten): V1 doesn't do this and it's a bug
i&&(this._updateMetrics([s]),this._positionItems(),this._updateScrollerSize()))},
/**
   * @param {!Array<!Object>} splices
   */
_adjustVirtualIndex:function(t){t.forEach((function(t){// We only need to care about changes happening above the current position
if(
// deselect removed items
t.removed.forEach(this._removeItem,this),t.index<this._virtualStart){var e=Math.max(t.addedCount-t.removed.length,t.index-this._virtualStart);this._virtualStart=this._virtualStart+e,this._focusedVirtualIndex>=0&&(this._focusedVirtualIndex=this._focusedVirtualIndex+e)}}),this)},_removeItem:function(t){this.$.selector.deselect(t),// remove the current focused item
this._focusedItem&&this.modelForElement(this._focusedItem)[this.as]===t&&this._removeFocusedItem()},
/**
   * Executes a provided function per every physical index in `itemSet`
   * `itemSet` default value is equivalent to the entire set of physical
   * indexes.
   *
   * @param {!function(number, number)} fn
   * @param {!Array<number>=} itemSet
   */
_iterateItems:function(t,e){var i,s,n,o;if(2===arguments.length&&e){for(o=0;o<e.length;o++)if(i=e[o],s=this._computeVidx(i),null!=(n=t.call(this,i,s)))return n}else{for(i=this._physicalStart,s=this._virtualStart;i<this._physicalCount;i++,s++)if(null!=(n=t.call(this,i,s)))return n;for(i=0;i<this._physicalStart;i++,s++)if(null!=(n=t.call(this,i,s)))return n}},
/**
   * Returns the virtual index for a given physical index
   *
   * @param {number} pidx Physical index
   * @return {number}
   */
_computeVidx:function(t){return t>=this._physicalStart?this._virtualStart+(t-this._physicalStart):this._virtualStart+(this._physicalCount-this._physicalStart)+t},
/**
   * Assigns the data models to a given set of items.
   * @param {!Array<number>=} itemSet
   */
_assignModels:function(t){this._iterateItems((function(t,e){var i=this._physicalItems[t],s=this.items&&this.items[e];if(null!=s){var n=this.modelForElement(i);n.__key__=null,this._forwardProperty(n,this.as,s),this._forwardProperty(n,this.selectedAs,this.$.selector.isSelected(s)),this._forwardProperty(n,this.indexAs,e),this._forwardProperty(n,"tabIndex",this._focusedVirtualIndex===e?0:-1),this._physicalIndexForKey[n.__key__]=t,n._flushProperties&&n._flushProperties(!0),i.removeAttribute("hidden")}else i.setAttribute("hidden","")}),t)},
/**
   * Updates the height for a given set of items.
   *
   * @param {!Array<number>=} itemSet
   */
_updateMetrics:function(t){
// Make sure we distributed all the physical items
// so we can measure them.
Object(u.b)();var e=0,i=0,s=this._physicalAverageCount,n=this._physicalAverage;this._iterateItems((function(t,s){i+=this._physicalSizes[t],this._physicalSizes[t]=this._physicalItems[t].offsetHeight,e+=this._physicalSizes[t],this._physicalAverageCount+=this._physicalSizes[t]?1:0}),t),this.grid?(this._updateGridMetrics(),this._physicalSize=Math.ceil(this._physicalCount/this._itemsPerRow)*this._rowHeight):(i=1===this._itemsPerRow?i:Math.ceil(this._physicalCount/this._itemsPerRow)*this._rowHeight,this._physicalSize=this._physicalSize+e-i,this._itemsPerRow=1),// Update the average if it measured something.
this._physicalAverageCount!==s&&(this._physicalAverage=Math.round((n*s+e)/this._physicalAverageCount))},_updateGridMetrics:function(){this._itemWidth=this._physicalCount>0?this._physicalItems[0].getBoundingClientRect().width:200,this._rowHeight=this._physicalCount>0?this._physicalItems[0].offsetHeight:200,this._itemsPerRow=this._itemWidth?Math.floor(this._viewportWidth/this._itemWidth):this._itemsPerRow},
/**
   * Updates the position of the physical items.
   */
_positionItems:function(){this._adjustScrollPosition();var t=this._physicalTop;if(this.grid){var e=this._itemsPerRow*this._itemWidth,i=(this._viewportWidth-e)/2;this._iterateItems((function(e,s){var n=s%this._itemsPerRow,o=Math.floor(n*this._itemWidth+i);this._isRTL&&(o*=-1),this.translate3d(o+"px",t+"px",0,this._physicalItems[e]),this._shouldRenderNextRow(s)&&(t+=this._rowHeight)}))}else{const e=[];this._iterateItems((function(i,s){const n=this._physicalItems[i];this.translate3d(0,t+"px",0,n),t+=this._physicalSizes[i];const o=n.id;o&&e.push(o)})),e.length&&this.setAttribute("aria-owns",e.join(" "))}},_getPhysicalSizeIncrement:function(t){return this.grid?this._computeVidx(t)%this._itemsPerRow!=this._itemsPerRow-1?0:this._rowHeight:this._physicalSizes[t]},
/**
   * Returns, based on the current index,
   * whether or not the next index will need
   * to be rendered on a new row.
   *
   * @param {number} vidx Virtual index
   * @return {boolean}
   */
_shouldRenderNextRow:function(t){return t%this._itemsPerRow==this._itemsPerRow-1},
/**
   * Adjusts the scroll position when it was overestimated.
   */
_adjustScrollPosition:function(){var t=0===this._virtualStart?this._physicalTop:Math.min(this._scrollPosition+this._physicalTop,0);// Note: the delta can be positive or negative.
if(0!==t){this._physicalTop=this._physicalTop-t;// This may be called outside of a scrollHandler, so use last cached position
var e=this._scrollPosition;// juking scroll position during interial scrolling on iOS is no bueno
!p&&e>0&&this._resetScrollPosition(e-t)}},
/**
   * Sets the position of the scroll.
   */
_resetScrollPosition:function(t){this.scrollTarget&&t>=0&&(this._scrollTop=t,this._scrollPosition=this._scrollTop)},
/**
   * Sets the scroll height, that's the height of the content,
   *
   * @param {boolean=} forceUpdate If true, updates the height no matter what.
   */
_updateScrollerSize:function(t){this.grid?this._estScrollHeight=this._virtualRowCount*this._rowHeight:this._estScrollHeight=this._physicalBottom+Math.max(this._virtualCount-this._physicalCount-this._virtualStart,0)*this._physicalAverage,// Amortize height adjustment, so it won't trigger large repaints too often.
((t=(t=(t=t||0===this._scrollHeight)||this._scrollPosition>=this._estScrollHeight-this._physicalSize)||this.grid&&this.$.items.style.height<this._estScrollHeight)||Math.abs(this._estScrollHeight-this._scrollHeight)>=this._viewportHeight)&&(this.$.items.style.height=this._estScrollHeight+"px",this._scrollHeight=this._estScrollHeight)},
/**
   * Scroll to a specific item in the virtual list regardless
   * of the physical items in the DOM tree.
   *
   * @method scrollToItem
   * @param {(Object)} item The item to be scrolled to
   */
scrollToItem:function(t){return this.scrollToIndex(this.items.indexOf(t))},
/**
   * Scroll to a specific index in the virtual list regardless
   * of the physical items in the DOM tree.
   *
   * @method scrollToIndex
   * @param {number} idx The index of the item
   */
scrollToIndex:function(t){if(!("number"!=typeof t||t<0||t>this.items.length-1)&&(Object(u.b)(),0!==this._physicalCount))// Items should have been rendered prior scrolling to an index.
{t=this._clamp(t,0,this._virtualCount-1),// Update the virtual start only when needed.
(!this._isIndexRendered(t)||t>=this._maxVirtualStart)&&(this._virtualStart=this.grid?t-2*this._itemsPerRow:t-1),this._manageFocus(),this._assignModels(),this._updateMetrics(),// Estimate new physical offset.
this._physicalTop=Math.floor(this._virtualStart/this._itemsPerRow)*this._physicalAverage;// scroll to the item as much as we can.
for(var e=this._physicalStart,i=this._virtualStart,s=0,n=this._hiddenContentSize;i<t&&s<=n;)s+=this._getPhysicalSizeIncrement(e),e=(e+1)%this._physicalCount,i++;this._updateScrollerSize(!0),this._positionItems(),this._resetScrollPosition(this._physicalTop+this._scrollOffset+s),this._increasePoolIfNeeded(0),// clear cached visible index.
this._firstVisibleIndexVal=null,this._lastVisibleIndexVal=null}},
/**
   * Reset the physical average and the average count.
   */
_resetAverage:function(){this._physicalAverage=0,this._physicalAverageCount=0},
/**
   * A handler for the `iron-resize` event triggered by `IronResizableBehavior`
   * when the element is resized.
   */
_resizeHandler:function(){this._debounce("_render",(function(){
// clear cached visible index.
this._firstVisibleIndexVal=null,this._lastVisibleIndexVal=null,this._isVisible?(this.updateViewportBoundaries(),// Reinstall the scroll event listener.
this.toggleScrollListener(!0),this._resetAverage(),this._render()):
// Uninstall the scroll event listener.
this.toggleScrollListener(!1)}),h.a)},
/**
   * Selects the given item.
   *
   * @method selectItem
   * @param {Object} item The item instance.
   */
selectItem:function(t){return this.selectIndex(this.items.indexOf(t))},
/**
   * Selects the item at the given index in the items array.
   *
   * @method selectIndex
   * @param {number} index The index of the item in the items array.
   */
selectIndex:function(t){if(!(t<0||t>=this._virtualCount)){if(!this.multiSelection&&this.selectedItem&&this.clearSelection(),this._isIndexRendered(t)){var e=this.modelForElement(this._physicalItems[this._getPhysicalIndex(t)]);e&&(e[this.selectedAs]=!0),this.updateSizeForIndex(t)}this.$.selector.selectIndex(t)}},
/**
   * Deselects the given item.
   *
   * @method deselect
   * @param {Object} item The item instance.
   */
deselectItem:function(t){return this.deselectIndex(this.items.indexOf(t))},
/**
   * Deselects the item at the given index in the items array.
   *
   * @method deselectIndex
   * @param {number} index The index of the item in the items array.
   */
deselectIndex:function(t){if(!(t<0||t>=this._virtualCount)){if(this._isIndexRendered(t))this.modelForElement(this._physicalItems[this._getPhysicalIndex(t)])[this.selectedAs]=!1,this.updateSizeForIndex(t);this.$.selector.deselectIndex(t)}},
/**
   * Selects or deselects a given item depending on whether the item
   * has already been selected.
   *
   * @method toggleSelectionForItem
   * @param {Object} item The item object.
   */
toggleSelectionForItem:function(t){return this.toggleSelectionForIndex(this.items.indexOf(t))},
/**
   * Selects or deselects the item at the given index in the items array
   * depending on whether the item has already been selected.
   *
   * @method toggleSelectionForIndex
   * @param {number} index The index of the item in the items array.
   */
toggleSelectionForIndex:function(t){(this.$.selector.isIndexSelected?this.$.selector.isIndexSelected(t):this.$.selector.isSelected(this.items[t]))?this.deselectIndex(t):this.selectIndex(t)},
/**
   * Clears the current selection in the list.
   *
   * @method clearSelection
   */
clearSelection:function(){this._iterateItems((function(t,e){this.modelForElement(this._physicalItems[t])[this.selectedAs]=!1})),this.$.selector.clearSelection()},
/**
   * Add an event listener to `tap` if `selectionEnabled` is true,
   * it will remove the listener otherwise.
   */
_selectionEnabledChanged:function(t){(t?this.listen:this.unlisten).call(this,this,"tap","_selectionHandler")},
/**
   * Select an item from an event object.
   */
_selectionHandler:function(t){var e=this.modelForElement(t.target);if(e){var i,s,n=Object(a.a)(t).path[0],o=this._getActiveElement(),r=this._physicalItems[this._getPhysicalIndex(e[this.indexAs])];// Safari does not focus certain form controls via mouse
// https://bugs.webkit.org/show_bug.cgi?id=118043
"input"!==n.localName&&"button"!==n.localName&&"select"!==n.localName&&(// Set a temporary tabindex
i=e.tabIndex,e.tabIndex=-100,s=o?o.tabIndex:-1,e.tabIndex=i,// Only select the item if the tap wasn't on a focusable child
// or the element bound to `tabIndex`
o&&r!==o&&r.contains(o)&&-100!==s||this.toggleSelectionForItem(e[this.as]))}},_multiSelectionChanged:function(t){this.clearSelection(),this.$.selector.multi=t},
/**
   * Updates the size of a given list item.
   *
   * @method updateSizeForItem
   * @param {Object} item The item instance.
   */
updateSizeForItem:function(t){return this.updateSizeForIndex(this.items.indexOf(t))},
/**
   * Updates the size of the item at the given index in the items array.
   *
   * @method updateSizeForIndex
   * @param {number} index The index of the item in the items array.
   */
updateSizeForIndex:function(t){return this._isIndexRendered(t)?(this._updateMetrics([this._getPhysicalIndex(t)]),this._positionItems(),null):null},
/**
   * Creates a temporary backfill item in the rendered pool of physical items
   * to replace the main focused item. The focused item has tabIndex = 0
   * and might be currently focused by the user.
   *
   * This dynamic replacement helps to preserve the focus state.
   */
_manageFocus:function(){var t=this._focusedVirtualIndex;t>=0&&t<this._virtualCount?
// if it's a valid index, check if that index is rendered
// in a physical item.
this._isIndexRendered(t)?this._restoreFocusedItem():this._createFocusBackfillItem():this._virtualCount>0&&this._physicalCount>0&&(
// otherwise, assign the initial focused index.
this._focusedPhysicalIndex=this._physicalStart,this._focusedVirtualIndex=this._virtualStart,this._focusedItem=this._physicalItems[this._physicalStart])},
/**
   * Converts a random index to the index of the item that completes it's row.
   * Allows for better order and fill computation when grid == true.
   */
_convertIndexToCompleteRow:function(t){
// when grid == false _itemPerRow can be unset.
return this._itemsPerRow=this._itemsPerRow||1,this.grid?Math.ceil(t/this._itemsPerRow)*this._itemsPerRow:t},_isIndexRendered:function(t){return t>=this._virtualStart&&t<=this._virtualEnd},_isIndexVisible:function(t){return t>=this.firstVisibleIndex&&t<=this.lastVisibleIndex},_getPhysicalIndex:function(t){return(this._physicalStart+(t-this._virtualStart))%this._physicalCount},focusItem:function(t){this._focusPhysicalItem(t)},_focusPhysicalItem:function(t){if(!(t<0||t>=this._virtualCount)){this._restoreFocusedItem(),// scroll to index to make sure it's rendered
this._isIndexRendered(t)||this.scrollToIndex(t);var e,i=this._physicalItems[this._getPhysicalIndex(t)],s=this.modelForElement(i);// set a secret tab index
s.tabIndex=-100,// check if focusable element is the physical item
-100===i.tabIndex&&(e=i),// search for the element which tabindex is bound to the secret tab index
e||(e=Object(a.a)(i).querySelector('[tabindex="-100"]')),// restore the tab index
s.tabIndex=0,// focus the focusable element
this._focusedVirtualIndex=t,e&&e.focus()}},_removeFocusedItem:function(){this._offscreenFocusedItem&&this._itemsParent.removeChild(this._offscreenFocusedItem),this._offscreenFocusedItem=null,this._focusBackfillItem=null,this._focusedItem=null,this._focusedVirtualIndex=-1,this._focusedPhysicalIndex=-1},_createFocusBackfillItem:function(){var t=this._focusedPhysicalIndex;if(!(this._offscreenFocusedItem||this._focusedVirtualIndex<0)){if(!this._focusBackfillItem){
// Create a physical item.
var e=this.stamp(null);this._focusBackfillItem=
/** @type {!HTMLElement} */
e.root.querySelector("*"),this._itemsParent.appendChild(e.root)}// Set the offcreen focused physical item.
this._offscreenFocusedItem=this._physicalItems[t],this.modelForElement(this._offscreenFocusedItem).tabIndex=0,this._physicalItems[t]=this._focusBackfillItem,this._focusedPhysicalIndex=t,// Hide the focused physical.
this.translate3d(0,"-10000px",0,this._offscreenFocusedItem)}},_restoreFocusedItem:function(){if(this._offscreenFocusedItem&&!(this._focusedVirtualIndex<0)){// Assign models to the focused index.
this._assignModels();// Get the new physical index for the focused index.
var t=this._focusedPhysicalIndex=this._getPhysicalIndex(this._focusedVirtualIndex),e=this._physicalItems[t];if(e){var i=this.modelForElement(e),s=this.modelForElement(this._offscreenFocusedItem);// Restores the physical item only when it has the same model
// as the offscreen one. Use key for comparison since users can set
// a new item via set('items.idx').
i[this.as]===s[this.as]?(
// Flip the focus backfill.
this._focusBackfillItem=e,i.tabIndex=-1,// Restore the focused physical item.
this._physicalItems[t]=this._offscreenFocusedItem,// Hide the physical item that backfills.
this.translate3d(0,"-10000px",0,this._focusBackfillItem)):(this._removeFocusedItem(),this._focusBackfillItem=null),this._offscreenFocusedItem=null}}},_didFocus:function(t){var e=this.modelForElement(t.target),i=this.modelForElement(this._focusedItem),s=null!==this._offscreenFocusedItem,n=this._focusedVirtualIndex;e&&(i===e?
// If the user focused the same item, then bring it into view if it's not
// visible.
this._isIndexVisible(n)||this.scrollToIndex(n):(this._restoreFocusedItem(),// Restore tabIndex for the currently focused item.
i&&(i.tabIndex=-1),// Set the tabIndex for the next focused item.
e.tabIndex=0,n=e[this.indexAs],this._focusedVirtualIndex=n,this._focusedPhysicalIndex=this._getPhysicalIndex(n),this._focusedItem=this._physicalItems[this._focusedPhysicalIndex],s&&!this._offscreenFocusedItem&&this._update()))},_keydownHandler:function(t){switch(t.keyCode){case
/* ARROW_DOWN */
40:this._focusedVirtualIndex<this._virtualCount-1&&t.preventDefault(),this._focusPhysicalItem(this._focusedVirtualIndex+(this.grid?this._itemsPerRow:1));break;case
/* ARROW_RIGHT */
39:this.grid&&this._focusPhysicalItem(this._focusedVirtualIndex+(this._isRTL?-1:1));break;case
/* ARROW_UP */
38:this._focusedVirtualIndex>0&&t.preventDefault(),this._focusPhysicalItem(this._focusedVirtualIndex-(this.grid?this._itemsPerRow:1));break;case
/* ARROW_LEFT */
37:this.grid&&this._focusPhysicalItem(this._focusedVirtualIndex+(this._isRTL?1:-1));break;case
/* ENTER */
13:this._focusPhysicalItem(this._focusedVirtualIndex),this.selectionEnabled&&this._selectionHandler(t)}},_clamp:function(t,e,i){return Math.min(i,Math.max(e,t))},_debounce:function(t,e,i){this._debouncers=this._debouncers||{},this._debouncers[t]=c.a.debounce(this._debouncers[t],i,e.bind(this)),Object(u.a)(this._debouncers[t])},_forwardProperty:function(t,e,i){t._setPendingProperty(e,i)},
/* Templatizer bindings for v2 */
_forwardHostPropV2:function(t,e){(this._physicalItems||[]).concat([this._offscreenFocusedItem,this._focusBackfillItem]).forEach((function(i){i&&this.modelForElement(i).forwardHostProp(t,e)}),this)},_notifyInstancePropV2:function(t,e,i){if(Object(f.e)(this.as,e)){var s=t[this.indexAs];e==this.as&&(this.items[s]=i),this.notifyPath(Object(f.i)(this.as,"items."+s,e),i)}},
/* Templatizer bindings for v1 */
_getStampedChildren:function(){return this._physicalItems},_forwardInstancePath:function(t,e,i){0===e.indexOf(this.as+".")&&this.notifyPath("items."+t.__key__+"."+e.slice(this.as.length+1),i)},_forwardParentPath:function(t,e){(this._physicalItems||[]).concat([this._offscreenFocusedItem,this._focusBackfillItem]).forEach((function(i){i&&this.modelForElement(i).notifyPath(t,e)}),this)},_forwardParentProp:function(t,e){(this._physicalItems||[]).concat([this._offscreenFocusedItem,this._focusBackfillItem]).forEach((function(i){i&&(this.modelForElement(i)[t]=e)}),this)},
/* Gets the activeElement of the shadow root/host that contains the list. */
_getActiveElement:function(){var t=this._itemsParent.node.domHost;return Object(a.a)(t?t.root:document).activeElement}})},
/***/wLOY:
/***/function(t,e,i){"use strict";
/* harmony export (binding) */i.d(e,"a",(function(){return o}));
/* harmony import */i("pYlh");
/* harmony import */var s=i("hvZu");
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
// IE11 has a bug where an element with (1) `overflow: auto;`, (2) size based on
// its content's natural size, (3) absolute positioning (either `absolute` or
// `fixed`), and (4) use `max-width` to constrain its width will place its
// vertical scrollbar outside the area constrained by `max-width`.
// Unlike other browsers, IE11 doesn't support changing the size of scrollbars
// with CSS, so we don't need to read this value live from the element in
// question when trying to work around the bug.
let n=void 0;const o={properties:{
/**
     * The element that will receive a `max-height`/`width`. By default it is
     * the same as `this`, but it can be set to a child element. This is useful,
     * for example, for implementing a scrolling region inside the element.
     * @type {!Element}
     */
sizingTarget:{type:Object,value:function(){return this}},
/**
     * The element to fit `this` into.
     */
fitInto:{type:Object,value:window},
/**
     * Will position the element around the positionTarget without overlapping
     * it.
     */
noOverlap:{type:Boolean},
/**
     * The element that should be used to position the element. If not set, it
     * will default to the parent node.
     * @type {!Element}
     */
positionTarget:{type:Element},
/**
     * The orientation against which to align the element horizontally
     * relative to the `positionTarget`. Possible values are "left", "right",
     * "center", "auto".
     */
horizontalAlign:{type:String},
/**
     * The orientation against which to align the element vertically
     * relative to the `positionTarget`. Possible values are "top", "bottom",
     * "middle", "auto".
     */
verticalAlign:{type:String},
/**
     * If true, it will use `horizontalAlign` and `verticalAlign` values as
     * preferred alignment and if there's not enough space, it will pick the
     * values which minimize the cropping.
     */
dynamicAlign:{type:Boolean},
/**
     * A pixel value that will be added to the position calculated for the
     * given `horizontalAlign`, in the direction of alignment. You can think
     * of it as increasing or decreasing the distance to the side of the
     * screen given by `horizontalAlign`.
     *
     * If `horizontalAlign` is "left" or "center", this offset will increase or
     * decrease the distance to the left side of the screen: a negative offset
     * will move the dropdown to the left; a positive one, to the right.
     *
     * Conversely if `horizontalAlign` is "right", this offset will increase
     * or decrease the distance to the right side of the screen: a negative
     * offset will move the dropdown to the right; a positive one, to the left.
     */
horizontalOffset:{type:Number,value:0,notify:!0},
/**
     * A pixel value that will be added to the position calculated for the
     * given `verticalAlign`, in the direction of alignment. You can think
     * of it as increasing or decreasing the distance to the side of the
     * screen given by `verticalAlign`.
     *
     * If `verticalAlign` is "top" or "middle", this offset will increase or
     * decrease the distance to the top side of the screen: a negative offset
     * will move the dropdown upwards; a positive one, downwards.
     *
     * Conversely if `verticalAlign` is "bottom", this offset will increase
     * or decrease the distance to the bottom side of the screen: a negative
     * offset will move the dropdown downwards; a positive one, upwards.
     */
verticalOffset:{type:Number,value:0,notify:!0},
/**
     * Set to true to auto-fit on attach.
     */
autoFitOnAttach:{type:Boolean,value:!1},
/**
     * If true and scrollbars are added to `sizingTarget` after it is
     * positioned, the size of the added scrollbars will be added to its
     * `maxWidth` and `maxHeight`.
     */
expandSizingTargetForScrollbars:{type:Boolean,value:!1},
/** @type {?Object} */
_fitInfo:{type:Object}},get _fitWidth(){return this.fitInto===window?this.fitInto.innerWidth:this.fitInto.getBoundingClientRect().width},get _fitHeight(){return this.fitInto===window?this.fitInto.innerHeight:this.fitInto.getBoundingClientRect().height},get _fitLeft(){return this.fitInto===window?0:this.fitInto.getBoundingClientRect().left},get _fitTop(){return this.fitInto===window?0:this.fitInto.getBoundingClientRect().top},
/**
   * The element that should be used to position the element,
   * if no position target is configured.
   */
get _defaultPositionTarget(){var t=Object(s.a)(this).parentNode;return t&&t.nodeType===Node.DOCUMENT_FRAGMENT_NODE&&(t=t.host),t},
/**
   * The horizontal align value, accounting for the RTL/LTR text direction.
   */
get _localeHorizontalAlign(){if(this._isRTL){
// In RTL, "left" becomes "right".
if("right"===this.horizontalAlign)return"left";if("left"===this.horizontalAlign)return"right"}return this.horizontalAlign},
/**
   * True if the element should be positioned instead of centered.
   * @private
   */
get __shouldPosition(){return(this.horizontalAlign||this.verticalAlign)&&this.positionTarget},
/**
   * True if the component is RTL.
   * @private
   */
get _isRTL(){
// Memoize this to avoid expensive calculations & relayouts.
// Make sure we do it only once
return void 0===this._memoizedIsRTL&&(this._memoizedIsRTL="rtl"==window.getComputedStyle(this).direction),this._memoizedIsRTL},
/** @override */
attached:function(){this.positionTarget=this.positionTarget||this._defaultPositionTarget,this.autoFitOnAttach&&("none"===window.getComputedStyle(this).display?setTimeout(function(){this.fit()}.bind(this)):(
// NOTE: shadydom applies distribution asynchronously
// for performance reasons webcomponents/shadydom#120
// Flush to get correct layout info.
window.ShadyDOM&&ShadyDOM.flush(),this.fit()))},
/** @override */
detached:function(){this.__deferredFit&&(clearTimeout(this.__deferredFit),this.__deferredFit=null)},
/**
   * Positions and fits the element into the `fitInto` element.
   */
fit:function(){this.position(),this.constrain(),this.center()},
/**
   * Memoize information needed to position and size the target element.
   * @suppress {deprecated}
   */
_discoverInfo:function(){if(!this._fitInfo){var t=window.getComputedStyle(this),e=window.getComputedStyle(this.sizingTarget);this._fitInfo={inlineStyle:{top:this.style.top||"",left:this.style.left||"",position:this.style.position||""},sizerInlineStyle:{maxWidth:this.sizingTarget.style.maxWidth||"",maxHeight:this.sizingTarget.style.maxHeight||"",boxSizing:this.sizingTarget.style.boxSizing||""},positionedBy:{vertically:"auto"!==t.top?"top":"auto"!==t.bottom?"bottom":null,horizontally:"auto"!==t.left?"left":"auto"!==t.right?"right":null},sizedBy:{height:"none"!==e.maxHeight,width:"none"!==e.maxWidth,minWidth:parseInt(e.minWidth,10)||0,minHeight:parseInt(e.minHeight,10)||0},margin:{top:parseInt(t.marginTop,10)||0,right:parseInt(t.marginRight,10)||0,bottom:parseInt(t.marginBottom,10)||0,left:parseInt(t.marginLeft,10)||0}}}},
/**
   * Resets the target element's position and size constraints, and clear
   * the memoized data.
   */
resetFit:function(){var t=this._fitInfo||{};for(var e in t.sizerInlineStyle)this.sizingTarget.style[e]=t.sizerInlineStyle[e];for(var e in t.inlineStyle)this.style[e]=t.inlineStyle[e];this._fitInfo=null},
/**
   * Equivalent to calling `resetFit()` and `fit()`. Useful to call this after
   * the element or the `fitInto` element has been resized, or if any of the
   * positioning properties (e.g. `horizontalAlign, verticalAlign`) is updated.
   * It preserves the scroll position of the sizingTarget.
   */
refit:function(){var t=this.sizingTarget.scrollLeft,e=this.sizingTarget.scrollTop;this.resetFit(),this.fit(),this.sizingTarget.scrollLeft=t,this.sizingTarget.scrollTop=e},
/**
   * Positions the element according to `horizontalAlign, verticalAlign`.
   */
position:function(){if(!this.__shouldPosition)
// needs to be centered, and it is done after constrain.
return;this._discoverInfo(),window.ShadyDOM&&window.ShadyDOM.flush(),this.style.position="fixed",// Need border-box for margin/padding.
this.sizingTarget.style.boxSizing="border-box",// Set to 0, 0 in order to discover any offset caused by parent stacking
// contexts.
this.style.left="0px",this.style.top="0px";var t=this.getBoundingClientRect(),e=this.__getNormalizedRect(this.positionTarget),i=this.__getNormalizedRect(this.fitInto);let s,o,r,a;this.expandSizingTargetForScrollbars&&(s=this.sizingTarget.offsetWidth,o=this.sizingTarget.offsetHeight,r=this.sizingTarget.clientWidth,a=this.sizingTarget.clientHeight);var l=this._fitInfo.margin,h={width:t.width+l.left+l.right,height:t.height+l.top+l.bottom},c=this.__getPosition(this._localeHorizontalAlign,this.verticalAlign,h,t,e,i),u=c.left+l.left,d=c.top+l.top,f=Math.min(i.right-l.right,u+t.width),_=Math.min(i.bottom-l.bottom,d+t.height);// Consider the margin as part of the size for position calculations.
// Keep left/top within fitInto respecting the margin.
u=Math.max(i.left+l.left,Math.min(u,f-this._fitInfo.sizedBy.minWidth)),d=Math.max(i.top+l.top,Math.min(d,_-this._fitInfo.sizedBy.minHeight));// Use right/bottom to set maxWidth/maxHeight, and respect
// minWidth/minHeight.
const p=Math.max(f-u,this._fitInfo.sizedBy.minWidth),y=Math.max(_-d,this._fitInfo.sizedBy.minHeight);this.sizingTarget.style.maxWidth=p+"px",this.sizingTarget.style.maxHeight=y+"px";// Remove the offset caused by any stacking context.
const g=u-t.left,m=d-t.top;if(this.style.left=g+"px",this.style.top=m+"px",this.expandSizingTargetForScrollbars){
// Expand the height first - i.e. in the typical block direction - in case
// this expands the element enough to remove the vertical scrollbar.
const t=this.sizingTarget.offsetHeight,e=t-this.sizingTarget.clientHeight-(o-a);if(e>0){
// Expand `maxHeight` by `sizingTargetScrollbarHeight` up to the overall
// allowed height within `fitRect`.
const s=i.height-l.top-l.bottom,n=Math.min(s,y+e);this.sizingTarget.style.maxHeight=n+"px";// Measure the element's real change in height. This may not equal
// `sizingTargetScrollbarHeight` if the overflow amount is less than the
// scrollbar size.
const o=this.sizingTarget.offsetHeight,r=o-t;// Adjust the top position if the alignment requires it.
let a;"top"===c.verticalAlign?a=m:"middle"===c.verticalAlign?a=m-r/2:"bottom"===c.verticalAlign&&(a=m-r),// Constrain the new top position based on `fitRect` again.
a=Math.max(i.top+l.top,Math.min(a,i.bottom-l.bottom-o)),this.style.top=a+"px"}const h=this.sizingTarget.offsetWidth,u=h-this.sizingTarget.clientWidth-(s-r);if(u>0){const t=(()=>{if(void 0!==n)return n;const t=document.createElement("div");Object.assign(t.style,{overflow:"auto",position:"fixed",left:"0px",top:"0px",maxWidth:"100px",maxHeight:"100px"});const e=document.createElement("div");return e.style.width="200px",e.style.height="200px",t.appendChild(e),document.body.appendChild(t),n=Math.abs(t.offsetWidth-100)>1?t.offsetWidth-t.clientWidth:0,document.body.removeChild(t),n})(),e=i.width-l.left-l.right,s=Math.min(e,p+u-t);// Expand `maxWidth` by `sizingTargetScrollbarWidth` up to the overall
// allowed width within `fitRect`.
this.sizingTarget.style.maxWidth=s+"px";// Measure the element's real change in width. This may not equal
// `sizingTargetScrollbarWidth` if the overflow amount is less than the
// scrollbar size.
const o=this.sizingTarget.offsetWidth+t,r=o-h;// Adjust the left position if the alignment requires it.
let a;"left"===c.horizontalAlign?a=g:"center"===c.horizontalAlign?a=g-r/2:"right"===c.horizontalAlign&&(a=g-r),// Constrain the new left position based on `fitRect` again.
a=Math.max(i.left+l.left,Math.min(a,i.right-l.right-o)),this.style.left=a+"px"}}},
/**
   * Constrains the size of the element to `fitInto` by setting `max-height`
   * and/or `max-width`.
   */
constrain:function(){if(!this.__shouldPosition){this._discoverInfo();var t=this._fitInfo;// position at (0px, 0px) if not already positioned, so we can measure the
// natural size.
t.positionedBy.vertically||(this.style.position="fixed",this.style.top="0px"),t.positionedBy.horizontally||(this.style.position="fixed",this.style.left="0px"),// need border-box for margin/padding
this.sizingTarget.style.boxSizing="border-box";// constrain the width and height if not already set
var e=this.getBoundingClientRect();t.sizedBy.height||this.__sizeDimension(e,t.positionedBy.vertically,"top","bottom","Height"),t.sizedBy.width||this.__sizeDimension(e,t.positionedBy.horizontally,"left","right","Width")}},
/**
   * @protected
   * @deprecated
   */
_sizeDimension:function(t,e,i,s,n){this.__sizeDimension(t,e,i,s,n)},
/**
   * @private
   */
__sizeDimension:function(t,e,i,s,n){var o=this._fitInfo,r=this.__getNormalizedRect(this.fitInto),a="Width"===n?r.width:r.height,l=e===s,h=l?a-t[s]:t[i],c=o.margin[l?i:s],u="offset"+n,d=this[u]-this.sizingTarget[u];this.sizingTarget.style["max"+n]=a-c-h-d+"px"},
/**
   * Centers horizontally and vertically if not already positioned. This also
   * sets `position:fixed`.
   */
center:function(){if(!this.__shouldPosition){this._discoverInfo();var t=this._fitInfo.positionedBy;if(!t.vertically||!t.horizontally){// Need position:fixed to center
this.style.position="fixed",// Take into account the offset caused by parents that create stacking
// contexts (e.g. with transform: translate3d). Translate to 0,0 and
// measure the bounding rect.
t.vertically||(this.style.top="0px"),t.horizontally||(this.style.left="0px");// It will take in consideration margins and transforms
var e=this.getBoundingClientRect(),i=this.__getNormalizedRect(this.fitInto);if(!t.vertically){var s=i.top-e.top+(i.height-e.height)/2;this.style.top=s+"px"}if(!t.horizontally){var n=i.left-e.left+(i.width-e.width)/2;this.style.left=n+"px"}}}},__getNormalizedRect:function(t){return t===document.documentElement||t===window?{top:0,left:0,width:window.innerWidth,height:window.innerHeight,right:window.innerWidth,bottom:window.innerHeight}:t.getBoundingClientRect()},__getOffscreenArea:function(t,e,i){var s=Math.min(0,t.top)+Math.min(0,i.bottom-(t.top+e.height)),n=Math.min(0,t.left)+Math.min(0,i.right-(t.left+e.width));return Math.abs(s)*e.width+Math.abs(n)*e.height},__getPosition:function(t,e,i,s,n,o){
// All the possible configurations.
// Ordered as top-left, top-right, bottom-left, bottom-right.
var r,a=[{verticalAlign:"top",horizontalAlign:"left",top:n.top+this.verticalOffset,left:n.left+this.horizontalOffset},{verticalAlign:"top",horizontalAlign:"right",top:n.top+this.verticalOffset,left:n.right-i.width-this.horizontalOffset},{verticalAlign:"bottom",horizontalAlign:"left",top:n.bottom-i.height-this.verticalOffset,left:n.left+this.horizontalOffset},{verticalAlign:"bottom",horizontalAlign:"right",top:n.bottom-i.height-this.verticalOffset,left:n.right-i.width-this.horizontalOffset}];if(this.noOverlap){
// Duplicate.
for(var l=0,h=a.length;l<h;l++){var c={};for(var u in a[l])c[u]=a[l][u];a.push(c)}// Horizontal overlap only.
a[0].top=a[1].top+=n.height,a[2].top=a[3].top-=n.height,// Vertical overlap only.
a[4].left=a[6].left+=n.width,a[5].left=a[7].left-=n.width}// Consider auto as null for coding convenience.
e="auto"===e?null:e,(t="auto"===t?null:t)&&"center"!==t||(a.push({verticalAlign:"top",horizontalAlign:"center",top:n.top+this.verticalOffset+(this.noOverlap?n.height:0),left:n.left-s.width/2+n.width/2+this.horizontalOffset}),a.push({verticalAlign:"bottom",horizontalAlign:"center",top:n.bottom-i.height-this.verticalOffset-(this.noOverlap?n.height:0),left:n.left-s.width/2+n.width/2+this.horizontalOffset})),e&&"middle"!==e||(a.push({verticalAlign:"middle",horizontalAlign:"left",top:n.top-s.height/2+n.height/2+this.verticalOffset,left:n.left+this.horizontalOffset+(this.noOverlap?n.width:0)}),a.push({verticalAlign:"middle",horizontalAlign:"right",top:n.top-s.height/2+n.height/2+this.verticalOffset,left:n.right-i.width-this.horizontalOffset-(this.noOverlap?n.width:0)})),"middle"===e&&"center"===t&&a.push({verticalAlign:"middle",horizontalAlign:"center",top:n.top-s.height/2+n.height/2+this.verticalOffset,left:n.left-s.width/2+n.width/2+this.horizontalOffset});for(l=0;l<a.length;l++){var d=a[l],f=d.verticalAlign===e,_=d.horizontalAlign===t;// If both vAlign and hAlign are defined, return exact match.
// For dynamicAlign and noOverlap we'll have more than one candidate, so
// we'll have to check the offscreenArea to make the best choice.
if(!this.dynamicAlign&&!this.noOverlap&&f&&_){r=d;break}// Align is ok if alignment preferences are respected. If no preferences,
// it is considered ok.
var p=(!e||f)&&(!t||_);// Filter out elements that don't match the alignment (if defined).
// With dynamicAlign, we need to consider all the positions to find the
// one that minimizes the cropped area.
if(this.dynamicAlign||p){// If not cropped and respects the align requirements, keep it.
// This allows to prefer positions overlapping horizontally over the
// ones overlapping vertically.
if(d.offscreenArea=this.__getOffscreenArea(d,i,o),0===d.offscreenArea&&p){r=d;break}r=r||d;var y=d.offscreenArea-r.offscreenArea;// Check which crops less. If it crops equally, check if at least one
// align setting is ok.
(y<0||0===y&&(f||_))&&(r=d)}}return r}};
/**
`Polymer.IronFitBehavior` fits an element in another element using `max-height`
and `max-width`, and optionally centers it in the window or another element.

The element will only be sized and/or positioned if it has not already been
sized and/or positioned by CSS.

CSS properties            | Action
--------------------------|-------------------------------------------
`position` set            | Element is not centered horizontally or vertically
`top` or `bottom` set     | Element is not vertically centered
`left` or `right` set     | Element is not horizontally centered
`max-height` set          | Element respects `max-height`
`max-width` set           | Element respects `max-width`

`Polymer.IronFitBehavior` can position an element into another element using
`verticalAlign` and `horizontalAlign`. This will override the element's css
position.

    <div class="container">
      <iron-fit-impl vertical-align="top" horizontal-align="auto">
        Positioned into the container
      </iron-fit-impl>
    </div>

Use `noOverlap` to position the element around another element without
overlapping it.

    <div class="container">
      <iron-fit-impl no-overlap vertical-align="auto" horizontal-align="auto">
        Positioned around the container
      </iron-fit-impl>
    </div>

Use `horizontalOffset, verticalOffset` to offset the element from its
`positionTarget`; `Polymer.IronFitBehavior` will collapse these in order to
keep the element within `fitInto` boundaries, while preserving the element's
CSS margin values.

    <div class="container">
      <iron-fit-impl vertical-align="top" vertical-offset="20">
        With vertical offset
      </iron-fit-impl>
    </div>

@demo demo/index.html
@polymerBehavior
*/},
/***/yWrR:
/***/function(t,e,i){"use strict";
// EXPORTS
i.d(e,"b",(function(){/* binding */return o})),i.d(e,"a",(function(){/* binding */return r}));
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/polymer-legacy.js?babel-target=es6
i("pYlh");
// CONCATENATED MODULE: ./node_modules/@polymer/iron-form-element-behavior/iron-form-element-behavior.js?babel-target=es6
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/**
  IronFormElementBehavior adds a `name`, `value` and `required` properties to
  a custom element. It mostly exists for backcompatibility with Polymer 1.x, and
  is probably not something you want to use.

  @demo demo/index.html
  @polymerBehavior
 */const s={properties:{
/**
     * The name of this element.
     */
name:{type:String},
/**
     * The value for this element.
     * @type {*}
     */
value:{notify:!0,type:String},
/**
     * Set to true to mark the input as required. If used in a form, a
     * custom element that uses this behavior should also use
     * IronValidatableBehavior and define a custom validation method.
     * Otherwise, a `required` element will always be considered valid.
     * It's also strongly recommended to provide a visual style for the element
     * when its value is invalid.
     */
required:{type:Boolean,value:!1}},
// Empty implementations for backcompatibility.
attached:function(){},detached:function(){}};
// EXTERNAL MODULE: ./node_modules/@polymer/iron-validatable-behavior/iron-validatable-behavior.js?babel-target=es6
var n=i("BQ7F");
// CONCATENATED MODULE: ./node_modules/@polymer/iron-checked-element-behavior/iron-checked-element-behavior.js?babel-target=es6
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/**
 * Use `IronCheckedElementBehavior` to implement a custom element that has a
 * `checked` property, which can be used for validation if the element is also
 * `required`. Element instances implementing this behavior will also be
 * registered for use in an `iron-form` element.
 *
 * @demo demo/index.html
 * @polymerBehavior IronCheckedElementBehavior
 */const o={properties:{
/**
     * Fired when the checked state changes.
     *
     * @event iron-change
     */
/**
     * Gets or sets the state, `true` is checked and `false` is unchecked.
     */
checked:{type:Boolean,value:!1,reflectToAttribute:!0,notify:!0,observer:"_checkedChanged"},
/**
     * If true, the button toggles the active state with each tap or press
     * of the spacebar.
     */
toggles:{type:Boolean,value:!0,reflectToAttribute:!0},
/* Overriden from IronFormElementBehavior */
value:{type:String,value:"on",observer:"_valueChanged"}},observers:["_requiredChanged(required)"],created:function(){
// Used by `iron-form` to handle the case that an element with this behavior
// doesn't have a role of 'checkbox' or 'radio', but should still only be
// included when the form is serialized if `this.checked === true`.
this._hasIronCheckedElementBehavior=!0},
/**
   * Returns false if the element is required and not checked, and true
   * otherwise.
   * @param {*=} _value Ignored.
   * @return {boolean} true if `required` is false or if `checked` is true.
   */
_getValidity:function(t){return this.disabled||!this.required||this.checked},
/**
   * Update the aria-required label when `required` is changed.
   */
_requiredChanged:function(){this.required?this.setAttribute("aria-required","true"):this.removeAttribute("aria-required")},
/**
   * Fire `iron-changed` when the checked state changes.
   */
_checkedChanged:function(){this.active=this.checked,this.fire("iron-change")},
/**
   * Reset value to 'on' if it is set to `undefined`.
   */
_valueChanged:function(){void 0!==this.value&&null!==this.value||(this.value="on")}},r=[s,n.a,o];
/** @polymerBehavior */}}]);